// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file terceros_finca_wizard.proto (package sextante.terceros.fincawizard.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file terceros_finca_wizard.proto.
 */
export const file_terceros_finca_wizard: GenFile = /*@__PURE__*/
  fileDesc("Cht0ZXJjZXJvc19maW5jYV93aXphcmQucHJvdG8SIHNleHRhbnRlLnRlcmNlcm9zLmZpbmNhd2l6YXJkLnYxIi8KGE9idGVuZXJUaWNrZXRNYXBhUmVxdWVzdBITCgtyZWdpc3Ryb19pZBgBIAEoCSI3ChJUaWNrZXRNYXBhUmVzcG9uc2USDgoGdGlja2V0GAEgASgJEhEKCWV4cGlyYV9lbhgCIAEoAyI8ChVMZWVyUGllemFQYWRyZVJlcXVlc3QSEwoLcmVnaXN0cm9faWQYASABKAkSDgoGaW5kaWNlGAIgASgFIj8KF0xlZXJMb3RlVGVtcG9yYWxSZXF1ZXN0EhMKC3JlZ2lzdHJvX2lkGAEgASgJEg8KB2xvdGVfaWQYAiABKAkiQQoZR2VvbWV0cmlhUmVnaXN0cm9SZXNwb25zZRIWCglnZW9tZXRyaWEYASABKAxIAIgBAUIMCgpfZ2VvbWV0cmlhIkoKGExlZXJWZXJ0aWNlc1BpZXphUmVxdWVzdBITCgtyZWdpc3Ryb19pZBgBIAEoCRIZChFwb2xpZ29ub19wYWRyZV9pZBgCIAEoCSInCgtWZXJ0aWNlTWFwYRILCgNsbmcYASABKAESCwoDbGF0GAIgASgBIlgKFVZlcnRpY2VzUGllemFSZXNwb25zZRI/Cgh2ZXJ0aWNlcxgBIAMoCzItLnNleHRhbnRlLnRlcmNlcm9zLmZpbmNhd2l6YXJkLnYxLlZlcnRpY2VNYXBhIloKGkFncmVnYXJWZXJ0aWNlVHJhem9SZXF1ZXN0EhMKC3JlZ2lzdHJvX2lkGAEgASgJEg0KBW9yZGVuGAIgASgFEgsKA2xuZxgDIAEoARILCgNsYXQYBCABKAEiPwoZUXVpdGFyVmVydGljZVRyYXpvUmVxdWVzdBITCgtyZWdpc3Ryb19pZBgBIAEoCRINCgVvcmRlbhgCIAEoBSIqChNMaW1waWFyVHJhem9SZXF1ZXN0EhMKC3JlZ2lzdHJvX2lkGAEgASgJIg8KDVRyYXpvUmVzcG9uc2Ui1QEKDExvdGVUZW1wb3JhbBIKCgJpZBgBIAEoCRIOCgZub21icmUYAiABKAkSEAoIYXJlYV9oYXMYAyABKAESHAoPYXJlYV9wcm9kdWN0aXZhGAQgASgISACIAQESFwoKY3VsdGl2b19pZBgFIAEoCUgBiAEBEhkKDGNvYmVydHVyYV9pZBgGIAEoCUgCiAEBEhEKCWdlb21ldHJpYRgHIAEoDEISChBfYXJlYV9wcm9kdWN0aXZhQg0KC19jdWx0aXZvX2lkQg8KDV9jb2JlcnR1cmFfaWQivgMKEFJlZ2lzdHJvVGVtcG9yYWwSCgoCaWQYASABKAkSFQoIZmluY2FfaWQYAiABKAlIAIgBARIOCgZub21icmUYAyABKAkSDAoEdGlwbxgEIAEoBRITCgt1bHRpbW9fcGFzbxgFIAEoBRITCgZmdWVudGUYBiABKAlIAYgBARIZCgxhb2lfc2F0ZWxpdGUYByABKAxIAogBARI9CgVsb3RlcxgIIAMoCzIuLnNleHRhbnRlLnRlcmNlcm9zLmZpbmNhd2l6YXJkLnYxLkxvdGVUZW1wb3JhbBISCgplc19lZGljaW9uGAogASgIEhcKD3BvbGlnb25vc19wYWRyZRgJIAMoDBIbChNwb2xpZ29ub3NfcGFkcmVfaWRzGAsgAygJEhsKDmFyY2hpdm9fbm9tYnJlGAwgASgJSAOIAQESJQoYYXJjaGl2b19hdmlzb19kZXB1cmFjaW9uGA0gASgJSASIAQFCCwoJX2ZpbmNhX2lkQgkKB19mdWVudGVCDwoNX2FvaV9zYXRlbGl0ZUIRCg9fYXJjaGl2b19ub21icmVCGwoZX2FyY2hpdm9fYXZpc29fZGVwdXJhY2lvbiIfCh1PYnRlbmVyUmVnaXN0cm9FbkN1cnNvUmVxdWVzdCJmCh5PYnRlbmVyUmVnaXN0cm9FbkN1cnNvUmVzcG9uc2USRAoIcmVnaXN0cm8YASABKAsyMi5zZXh0YW50ZS50ZXJjZXJvcy5maW5jYXdpemFyZC52MS5SZWdpc3Ryb1RlbXBvcmFsIi4KGkluaWNpYXJFZGljaW9uRmluY2FSZXF1ZXN0EhAKCGZpbmNhX2lkGAEgASgJIogBChpHdWFyZGFyRGF0b3NCYXNpY29zUmVxdWVzdBIYCgtyZWdpc3Ryb19pZBgBIAEoCUgAiAEBEhUKCGZpbmNhX2lkGAIgASgJSAGIAQESDgoGbm9tYnJlGAMgASgJEgwKBHRpcG8YBCABKAVCDgoMX3JlZ2lzdHJvX2lkQgsKCV9maW5jYV9pZCI7ChRHdWFyZGFyRnVlbnRlUmVxdWVzdBITCgtyZWdpc3Ryb19pZBgBIAEoCRIOCgZmdWVudGUYAiABKAkiMgoVR3VhcmRhckZ1ZW50ZVJlc3BvbnNlEhkKEWRhdG9zX2Rlc2NhcnRhZG9zGAEgASgIIpABChFHdWFyZGFyQW9pUmVxdWVzdBITCgtyZWdpc3Ryb19pZBgBIAEoCRIYCgxhb2lfc2F0ZWxpdGUYAiABKAxCAhgBEhcKD3BvbGlnb25vc19wYWRyZRgDIAMoDBIWCg5jb25zZXJ2YXJfcGFzbxgEIAEoCBIbChNwb2xpZ29ub3NfcGFkcmVfaWRzGAUgAygJImAKEkd1YXJkYXJBb2lSZXNwb25zZRIYChBsb3Rlc19lbGltaW5hZG9zGAEgASgIEhMKC2FyZWFfY2FtYmlvGAIgASgIEhsKE3BvbGlnb25vc19wYWRyZV9pZHMYAyADKAkitAEKCUxvdGVOdWV2bxIOCgZub21icmUYASABKAkSEQoJZ2VvbWV0cmlhGAIgASgMEhwKD2FyZWFfcHJvZHVjdGl2YRgDIAEoCEgAiAEBEhcKCmN1bHRpdm9faWQYBCABKAlIAYgBARIZCgxjb2JlcnR1cmFfaWQYBSABKAlIAogBAUISChBfYXJlYV9wcm9kdWN0aXZhQg0KC19jdWx0aXZvX2lkQg8KDV9jb2JlcnR1cmFfaWQiUQoIUGllemFBb2kSEQoJZ2VvbWV0cmlhGAEgASgMEhMKBm5vbWJyZRgCIAEoCUgAiAEBEhIKCm1vZGlmaWNhZGEYAyABKAhCCQoHX25vbWJyZSJpChZDb25maXJtYXJQaWV6YXNSZXF1ZXN0EhMKC3JlZ2lzdHJvX2lkGAEgASgJEjoKBnBpZXphcxgCIAMoCzIqLnNleHRhbnRlLnRlcmNlcm9zLmZpbmNhd2l6YXJkLnYxLlBpZXphQW9pIloKGUltcG9ydGFyQXJjaGl2b0ttbFJlcXVlc3QSEwoLcmVnaXN0cm9faWQYASABKAkSEAoIYmxvYl91cmwYAiABKAkSFgoObm9tYnJlX2FyY2hpdm8YAyABKAkiaAoaSW1wb3J0YXJBcmNoaXZvS21sUmVzcG9uc2USFwoPcG9saWdvbm9zX3BhZHJlGAEgAygMEhcKD2xvdGVzX2d1YXJkYWRvcxgCIAEoBRIYChBhdmlzb19kZXB1cmFjaW9uGAMgASgJImYKE0luaWNpYXJMb3Rlc1JlcXVlc3QSEwoLcmVnaXN0cm9faWQYASABKAkSOgoFbG90ZXMYAiADKAsyKy5zZXh0YW50ZS50ZXJjZXJvcy5maW5jYXdpemFyZC52MS5Mb3RlTnVldm8iLgoNTG90ZUdlb21ldHJpYRIKCgJpZBgBIAEoCRIRCglnZW9tZXRyaWEYAiABKAwiwQEKGEVkaXRhclZlcnRpY2VMb3RlUmVxdWVzdBITCgtyZWdpc3Ryb19pZBgBIAEoCRITCgZvcmlnZW4YAiABKAxIAIgBARIUCgdkZXN0aW5vGAMgASgMSAGIAQESFAoHbG90ZV9pZBgEIAEoCUgCiAEBEhoKDWluZGljZV9hcmlzdGEYBSABKAVIA4gBAUIJCgdfb3JpZ2VuQgoKCF9kZXN0aW5vQgoKCF9sb3RlX2lkQhAKDl9pbmRpY2VfYXJpc3RhIloKGUVkaXRhclZlcnRpY2VMb3RlUmVzcG9uc2USPQoFbG90ZXMYASADKAsyLi5zZXh0YW50ZS50ZXJjZXJvcy5maW5jYXdpemFyZC52MS5Mb3RlVGVtcG9yYWwi3gEKIUVkaXRhclZlcnRpY2VQb2xpZ29ub1BhZHJlUmVxdWVzdBITCgtyZWdpc3Ryb19pZBgBIAEoCRITCgZvcmlnZW4YAiABKAxIAIgBARIUCgdkZXN0aW5vGAMgASgMSAGIAQESHgoRcG9saWdvbm9fcGFkcmVfaWQYBCABKAlIAogBARIaCg1pbmRpY2VfYXJpc3RhGAUgASgFSAOIAQFCCQoHX29yaWdlbkIKCghfZGVzdGlub0IUChJfcG9saWdvbm9fcGFkcmVfaWRCEAoOX2luZGljZV9hcmlzdGEiZQoiRWRpdGFyVmVydGljZVBvbGlnb25vUGFkcmVSZXNwb25zZRI/CgZwaWV6YXMYASADKAsyLy5zZXh0YW50ZS50ZXJjZXJvcy5maW5jYXdpemFyZC52MS5Mb3RlR2VvbWV0cmlhIk0KEFVuaXJMb3Rlc1JlcXVlc3QSEwoLcmVnaXN0cm9faWQYASABKAkSEQoJbG90ZV9pZF9hGAIgASgJEhEKCWxvdGVfaWRfYhgDIAEoCSJpChFVbmlyTG90ZXNSZXNwb25zZRI9CgVsb3RlcxgBIAMoCzIuLnNleHRhbnRlLnRlcmNlcm9zLmZpbmNhd2l6YXJkLnYxLkxvdGVUZW1wb3JhbBIVCg1sb3RlX3VuaWRvX2lkGAIgASgJImkKE0RpdmlkaXJMb3RlUmVzcG9uc2USPQoFbG90ZXMYASADKAsyLi5zZXh0YW50ZS50ZXJjZXJvcy5maW5jYXdpemFyZC52MS5Mb3RlVGVtcG9yYWwSEwoLbWl0YWRlc19pZHMYAiADKAkiSQoSRGl2aWRpckxvdGVSZXF1ZXN0EhMKC3JlZ2lzdHJvX2lkGAEgASgJEg8KB2xvdGVfaWQYAiABKAkSDQoFbGluZWEYAyABKAwiQgocVmFsaWRhckF1dG9jaWVycmVMb3RlUmVxdWVzdBITCgtyZWdpc3Ryb19pZBgBIAEoCRINCgV0cmF6bxgCIAEoDCJRCh1WYWxpZGFyQXV0b2NpZXJyZUxvdGVSZXNwb25zZRIOCgZ2YWxpZG8YASABKAgSDgoGbW90aXZvGAIgASgJEhAKCGFyZWFfaGFzGAMgASgBIjgKEkRpYnVqYXJMb3RlUmVxdWVzdBITCgtyZWdpc3Ryb19pZBgBIAEoCRINCgV0cmF6bxgCIAEoDCKAAQoTRGlidWphckxvdGVSZXNwb25zZRI9CgVsb3RlcxgBIAMoCzIuLnNleHRhbnRlLnRlcmNlcm9zLmZpbmNhd2l6YXJkLnYxLkxvdGVUZW1wb3JhbBIVCg1sb3RlX251ZXZvX2lkGAIgASgJEhMKC2F1dG9jZXJyYWRvGAMgASgIItABChZSZWVtcGxhemFyTG90ZXNSZXF1ZXN0EhMKC3JlZ2lzdHJvX2lkGAEgASgJEhQKDGVsaW1pbmFyX2lkcxgCIAMoCRI8CgdhZ3JlZ2FyGAMgAygLMisuc2V4dGFudGUudGVyY2Vyb3MuZmluY2F3aXphcmQudjEuTG90ZU51ZXZvEk0KFGFjdHVhbGl6YXJfZ2VvbWV0cmlhGAQgAygLMi8uc2V4dGFudGUudGVyY2Vyb3MuZmluY2F3aXphcmQudjEuTG90ZUdlb21ldHJpYSJYChdMb3Rlc1RlbXBvcmFsZXNSZXNwb25zZRI9CgVsb3RlcxgBIAMoCzIuLnNleHRhbnRlLnRlcmNlcm9zLmZpbmNhd2l6YXJkLnYxLkxvdGVUZW1wb3JhbCKWAQoOQXNpZ25hY2lvbkxvdGUSHAoPYXJlYV9wcm9kdWN0aXZhGAEgASgISACIAQESFwoKY3VsdGl2b19pZBgCIAEoCUgBiAEBEhkKDGNvYmVydHVyYV9pZBgDIAEoCUgCiAEBQhIKEF9hcmVhX3Byb2R1Y3RpdmFCDQoLX2N1bHRpdm9faWRCDwoNX2NvYmVydHVyYV9pZCKFAQoRTG90ZUFjdHVhbGl6YWNpb24SCgoCaWQYASABKAkSEwoGbm9tYnJlGAIgASgJSACIAQESRAoKYXNpZ25hY2lvbhgDIAEoCzIwLnNleHRhbnRlLnRlcmNlcm9zLmZpbmNhd2l6YXJkLnYxLkFzaWduYWNpb25Mb3RlQgkKB19ub21icmUicQoWQWN0dWFsaXphckxvdGVzUmVxdWVzdBITCgtyZWdpc3Ryb19pZBgBIAEoCRJCCgVsb3RlcxgCIAMoCzIzLnNleHRhbnRlLnRlcmNlcm9zLmZpbmNhd2l6YXJkLnYxLkxvdGVBY3R1YWxpemFjaW9uIhkKF0FjdHVhbGl6YXJMb3Rlc1Jlc3BvbnNlIjcKEkF2YW56YXJQYXNvUmVxdWVzdBITCgtyZWdpc3Ryb19pZBgBIAEoCRIMCgRwYXNvGAIgASgFIhUKE0F2YW56YXJQYXNvUmVzcG9uc2UiJwoQRmluYWxpemFyUmVxdWVzdBITCgtyZWdpc3Ryb19pZBgBIAEoCSInChBEZXNjYXJ0YXJSZXF1ZXN0EhMKC3JlZ2lzdHJvX2lkGAEgASgJIhMKEURlc2NhcnRhclJlc3BvbnNlIiYKFFZhbGlkYXJOb21icmVSZXF1ZXN0Eg4KBm5vbWJyZRgBIAEoCSIXChVWYWxpZGFyTm9tYnJlUmVzcG9uc2UiOwoXVmFsaWRhckdlb21ldHJpYVJlcXVlc3QSIAoYYXJlYV9nZW9ncmFmaWNhX3NhdGVsaXRlGAEgASgMIhoKGFZhbGlkYXJHZW9tZXRyaWFSZXNwb25zZSK0AQoITG90ZUl0ZW0SEwoLbm9tYnJlX2xvdGUYASABKAkSHwoXYXJlYV9nZW9ncmFmaWNhX3BvbHlnb24YAiABKAwSGwoObG90ZV9vcmlnZW5faWQYAyABKAlIAIgBARIaChJpc19hcmVhX3Byb2R1Y3RpdmEYBCABKAgSFwoKY3VsdGl2b19pZBgFIAEoCUgBiAEBQhEKD19sb3RlX29yaWdlbl9pZEINCgtfY3VsdGl2b19pZCKLAQoOR3VhcmRhclJlcXVlc3QSDgoGbm9tYnJlGAEgASgJEgwKBHRpcG8YAiABKAUSIAoYYXJlYV9nZW9ncmFmaWNhX3NhdGVsaXRlGAMgASgMEjkKBWxvdGVzGAQgAygLMiouc2V4dGFudGUudGVyY2Vyb3MuZmluY2F3aXphcmQudjEuTG90ZUl0ZW0ilAEKFUNvbXBsZXRhckZpbmNhUmVxdWVzdBIQCghmaW5jYV9pZBgBIAEoCRIMCgR0aXBvGAIgASgFEiAKGGFyZWFfZ2VvZ3JhZmljYV9zYXRlbGl0ZRgDIAEoDBI5CgVsb3RlcxgEIAMoCzIqLnNleHRhbnRlLnRlcmNlcm9zLmZpbmNhd2l6YXJkLnYxLkxvdGVJdGVtIvwBCgxMb3RlR3VhcmRhZG8SCgoCaWQYASABKAkSEAoIZmluY2FfaWQYAiABKAkSEwoLbm9tYnJlX2xvdGUYAyABKAkSFgoOYXJlYV9oZWN0YXJlYXMYBCABKAESFAoMYXJlYV9jdWFkcmFzGAUgASgBEhoKEmlzX2FyZWFfcHJvZHVjdGl2YRgGIAEoCBIXCg9hcmVhX2dlb2dyYWZpY2EYByABKAwSFwoKY3VsdGl2b19pZBgIIAEoCUgAiAEBEhsKDmN1bHRpdm9fbm9tYnJlGAkgASgJSAGIAQFCDQoLX2N1bHRpdm9faWRCEQoPX2N1bHRpdm9fbm9tYnJlIt4HCg9HdWFyZGFyUmVzcG9uc2USCgoCaWQYASABKAkSFAoMbm9tYnJlX2ZpbmNhGAIgASgJEhcKD2hlY3RhcmVhc19maW5jYRgDIAEoARIdChVoZWN0YXJlYXNfcHJvZHVjdGl2YXMYBCABKAESEgoKdGlwb19maW5jYRgFIAEoBRIWCgl1YmljYWNpb24YBiABKAxIAIgBARIlChhzYXRlbGl0ZV9hcmVhX2dlb2dyYWZpY2EYByABKAxIAYgBARISCgpjbGllbnRlX2lkGAggASgJEhwKD2RlcGFydGFtZW50b19pZBgJIAEoCUgCiAEBEiAKE2RlcGFydGFtZW50b19ub21icmUYCiABKAlIA4gBARIZCgxtdW5pY2lwaW9faWQYCyABKAlIBIgBARIdChBtdW5pY2lwaW9fbm9tYnJlGAwgASgJSAWIAQESIwoWZGVwYXJ0YW1lbnRvX3JlZ2lvbl9pZBgNIAEoCUgGiAEBEicKGmRlcGFydGFtZW50b19yZWdpb25fbm9tYnJlGA4gASgJSAeIAQESJwofZ2FuYWRlcmlhX2NyZWNpbWllbnRvX2RpYXJpb19nchgPIAEoARImCh5nYW5hZGVyaWFfZGlhc19kZXNjYW5zb19vcHRpbW8YECABKAUSJwofZ2FuYWRlcmlhX2RpYXNfb2N1cGFjaW9uX29wdGltbxgRIAEoBRIsCiRnYW5hZGVyaWFfYW5pbWFsZXNfeF9oZWN0YXJlYV9vcHRpbW8YEiABKAESGgoSYXJib2xlc19tb25pdG9yZWFyGBMgASgFEhwKD3VyaV9vcnRvbW9zYWljbxgUIAEoCUgIiAEBEh4KEWNvbnRlb19wcmVfcmVuZGVyGBUgASgJSAmIAQESIAoYcGFzb19yZWdpc3Ryb19jb21wbGV0YWRvGBYgASgFEj0KBWxvdGVzGBcgAygLMi4uc2V4dGFudGUudGVyY2Vyb3MuZmluY2F3aXphcmQudjEuTG90ZUd1YXJkYWRvQgwKCl91YmljYWNpb25CGwoZX3NhdGVsaXRlX2FyZWFfZ2VvZ3JhZmljYUISChBfZGVwYXJ0YW1lbnRvX2lkQhYKFF9kZXBhcnRhbWVudG9fbm9tYnJlQg8KDV9tdW5pY2lwaW9faWRCEwoRX211bmljaXBpb19ub21icmVCGQoXX2RlcGFydGFtZW50b19yZWdpb25faWRCHQobX2RlcGFydGFtZW50b19yZWdpb25fbm9tYnJlQhIKEF91cmlfb3J0b21vc2FpY29CFAoSX2NvbnRlb19wcmVfcmVuZGVyMssfChlDbGllbnRlRmluY2FXaXphcmRTZXJ2aWNlEoABCg1WYWxpZGFyTm9tYnJlEjYuc2V4dGFudGUudGVyY2Vyb3MuZmluY2F3aXphcmQudjEuVmFsaWRhck5vbWJyZVJlcXVlc3QaNy5zZXh0YW50ZS50ZXJjZXJvcy5maW5jYXdpemFyZC52MS5WYWxpZGFyTm9tYnJlUmVzcG9uc2USiQEKEFZhbGlkYXJHZW9tZXRyaWESOS5zZXh0YW50ZS50ZXJjZXJvcy5maW5jYXdpemFyZC52MS5WYWxpZGFyR2VvbWV0cmlhUmVxdWVzdBo6LnNleHRhbnRlLnRlcmNlcm9zLmZpbmNhd2l6YXJkLnYxLlZhbGlkYXJHZW9tZXRyaWFSZXNwb25zZRJuCgdHdWFyZGFyEjAuc2V4dGFudGUudGVyY2Vyb3MuZmluY2F3aXphcmQudjEuR3VhcmRhclJlcXVlc3QaMS5zZXh0YW50ZS50ZXJjZXJvcy5maW5jYXdpemFyZC52MS5HdWFyZGFyUmVzcG9uc2USfAoOQ29tcGxldGFyRmluY2ESNy5zZXh0YW50ZS50ZXJjZXJvcy5maW5jYXdpemFyZC52MS5Db21wbGV0YXJGaW5jYVJlcXVlc3QaMS5zZXh0YW50ZS50ZXJjZXJvcy5maW5jYXdpemFyZC52MS5HdWFyZGFyUmVzcG9uc2USmwEKFk9idGVuZXJSZWdpc3Ryb0VuQ3Vyc28SPy5zZXh0YW50ZS50ZXJjZXJvcy5maW5jYXdpemFyZC52MS5PYnRlbmVyUmVnaXN0cm9FbkN1cnNvUmVxdWVzdBpALnNleHRhbnRlLnRlcmNlcm9zLmZpbmNhd2l6YXJkLnYxLk9idGVuZXJSZWdpc3Ryb0VuQ3Vyc29SZXNwb25zZRKHAQoTSW5pY2lhckVkaWNpb25GaW5jYRI8LnNleHRhbnRlLnRlcmNlcm9zLmZpbmNhd2l6YXJkLnYxLkluaWNpYXJFZGljaW9uRmluY2FSZXF1ZXN0GjIuc2V4dGFudGUudGVyY2Vyb3MuZmluY2F3aXphcmQudjEuUmVnaXN0cm9UZW1wb3JhbBKHAQoTR3VhcmRhckRhdG9zQmFzaWNvcxI8LnNleHRhbnRlLnRlcmNlcm9zLmZpbmNhd2l6YXJkLnYxLkd1YXJkYXJEYXRvc0Jhc2ljb3NSZXF1ZXN0GjIuc2V4dGFudGUudGVyY2Vyb3MuZmluY2F3aXphcmQudjEuUmVnaXN0cm9UZW1wb3JhbBKAAQoNR3VhcmRhckZ1ZW50ZRI2LnNleHRhbnRlLnRlcmNlcm9zLmZpbmNhd2l6YXJkLnYxLkd1YXJkYXJGdWVudGVSZXF1ZXN0Gjcuc2V4dGFudGUudGVyY2Vyb3MuZmluY2F3aXphcmQudjEuR3VhcmRhckZ1ZW50ZVJlc3BvbnNlEo8BChJJbXBvcnRhckFyY2hpdm9LbWwSOy5zZXh0YW50ZS50ZXJjZXJvcy5maW5jYXdpemFyZC52MS5JbXBvcnRhckFyY2hpdm9LbWxSZXF1ZXN0Gjwuc2V4dGFudGUudGVyY2Vyb3MuZmluY2F3aXphcmQudjEuSW1wb3J0YXJBcmNoaXZvS21sUmVzcG9uc2USdwoKR3VhcmRhckFvaRIzLnNleHRhbnRlLnRlcmNlcm9zLmZpbmNhd2l6YXJkLnYxLkd1YXJkYXJBb2lSZXF1ZXN0GjQuc2V4dGFudGUudGVyY2Vyb3MuZmluY2F3aXphcmQudjEuR3VhcmRhckFvaVJlc3BvbnNlEqcBChpFZGl0YXJWZXJ0aWNlUG9saWdvbm9QYWRyZRJDLnNleHRhbnRlLnRlcmNlcm9zLmZpbmNhd2l6YXJkLnYxLkVkaXRhclZlcnRpY2VQb2xpZ29ub1BhZHJlUmVxdWVzdBpELnNleHRhbnRlLnRlcmNlcm9zLmZpbmNhd2l6YXJkLnYxLkVkaXRhclZlcnRpY2VQb2xpZ29ub1BhZHJlUmVzcG9uc2UShgEKD0NvbmZpcm1hclBpZXphcxI4LnNleHRhbnRlLnRlcmNlcm9zLmZpbmNhd2l6YXJkLnYxLkNvbmZpcm1hclBpZXphc1JlcXVlc3QaOS5zZXh0YW50ZS50ZXJjZXJvcy5maW5jYXdpemFyZC52MS5Mb3Rlc1RlbXBvcmFsZXNSZXNwb25zZRKAAQoMSW5pY2lhckxvdGVzEjUuc2V4dGFudGUudGVyY2Vyb3MuZmluY2F3aXphcmQudjEuSW5pY2lhckxvdGVzUmVxdWVzdBo5LnNleHRhbnRlLnRlcmNlcm9zLmZpbmNhd2l6YXJkLnYxLkxvdGVzVGVtcG9yYWxlc1Jlc3BvbnNlEoYBCg9SZWVtcGxhemFyTG90ZXMSOC5zZXh0YW50ZS50ZXJjZXJvcy5maW5jYXdpemFyZC52MS5SZWVtcGxhemFyTG90ZXNSZXF1ZXN0Gjkuc2V4dGFudGUudGVyY2Vyb3MuZmluY2F3aXphcmQudjEuTG90ZXNUZW1wb3JhbGVzUmVzcG9uc2USegoLRGl2aWRpckxvdGUSNC5zZXh0YW50ZS50ZXJjZXJvcy5maW5jYXdpemFyZC52MS5EaXZpZGlyTG90ZVJlcXVlc3QaNS5zZXh0YW50ZS50ZXJjZXJvcy5maW5jYXdpemFyZC52MS5EaXZpZGlyTG90ZVJlc3BvbnNlEnQKCVVuaXJMb3RlcxIyLnNleHRhbnRlLnRlcmNlcm9zLmZpbmNhd2l6YXJkLnYxLlVuaXJMb3Rlc1JlcXVlc3QaMy5zZXh0YW50ZS50ZXJjZXJvcy5maW5jYXdpemFyZC52MS5VbmlyTG90ZXNSZXNwb25zZRKMAQoRRWRpdGFyVmVydGljZUxvdGUSOi5zZXh0YW50ZS50ZXJjZXJvcy5maW5jYXdpemFyZC52MS5FZGl0YXJWZXJ0aWNlTG90ZVJlcXVlc3QaOy5zZXh0YW50ZS50ZXJjZXJvcy5maW5jYXdpemFyZC52MS5FZGl0YXJWZXJ0aWNlTG90ZVJlc3BvbnNlEpgBChVWYWxpZGFyQXV0b2NpZXJyZUxvdGUSPi5zZXh0YW50ZS50ZXJjZXJvcy5maW5jYXdpemFyZC52MS5WYWxpZGFyQXV0b2NpZXJyZUxvdGVSZXF1ZXN0Gj8uc2V4dGFudGUudGVyY2Vyb3MuZmluY2F3aXphcmQudjEuVmFsaWRhckF1dG9jaWVycmVMb3RlUmVzcG9uc2USegoLRGlidWphckxvdGUSNC5zZXh0YW50ZS50ZXJjZXJvcy5maW5jYXdpemFyZC52MS5EaWJ1amFyTG90ZVJlcXVlc3QaNS5zZXh0YW50ZS50ZXJjZXJvcy5maW5jYXdpemFyZC52MS5EaWJ1amFyTG90ZVJlc3BvbnNlEoYBCg9BY3R1YWxpemFyTG90ZXMSOC5zZXh0YW50ZS50ZXJjZXJvcy5maW5jYXdpemFyZC52MS5BY3R1YWxpemFyTG90ZXNSZXF1ZXN0Gjkuc2V4dGFudGUudGVyY2Vyb3MuZmluY2F3aXphcmQudjEuQWN0dWFsaXphckxvdGVzUmVzcG9uc2USegoLQXZhbnphclBhc28SNC5zZXh0YW50ZS50ZXJjZXJvcy5maW5jYXdpemFyZC52MS5BdmFuemFyUGFzb1JlcXVlc3QaNS5zZXh0YW50ZS50ZXJjZXJvcy5maW5jYXdpemFyZC52MS5BdmFuemFyUGFzb1Jlc3BvbnNlEnIKCUZpbmFsaXphchIyLnNleHRhbnRlLnRlcmNlcm9zLmZpbmNhd2l6YXJkLnYxLkZpbmFsaXphclJlcXVlc3QaMS5zZXh0YW50ZS50ZXJjZXJvcy5maW5jYXdpemFyZC52MS5HdWFyZGFyUmVzcG9uc2USdAoJRGVzY2FydGFyEjIuc2V4dGFudGUudGVyY2Vyb3MuZmluY2F3aXphcmQudjEuRGVzY2FydGFyUmVxdWVzdBozLnNleHRhbnRlLnRlcmNlcm9zLmZpbmNhd2l6YXJkLnYxLkRlc2NhcnRhclJlc3BvbnNlEoUBChFPYnRlbmVyVGlja2V0TWFwYRI6LnNleHRhbnRlLnRlcmNlcm9zLmZpbmNhd2l6YXJkLnYxLk9idGVuZXJUaWNrZXRNYXBhUmVxdWVzdBo0LnNleHRhbnRlLnRlcmNlcm9zLmZpbmNhd2l6YXJkLnYxLlRpY2tldE1hcGFSZXNwb25zZRKGAQoOTGVlclBpZXphUGFkcmUSNy5zZXh0YW50ZS50ZXJjZXJvcy5maW5jYXdpemFyZC52MS5MZWVyUGllemFQYWRyZVJlcXVlc3QaOy5zZXh0YW50ZS50ZXJjZXJvcy5maW5jYXdpemFyZC52MS5HZW9tZXRyaWFSZWdpc3Ryb1Jlc3BvbnNlEooBChBMZWVyTG90ZVRlbXBvcmFsEjkuc2V4dGFudGUudGVyY2Vyb3MuZmluY2F3aXphcmQudjEuTGVlckxvdGVUZW1wb3JhbFJlcXVlc3QaOy5zZXh0YW50ZS50ZXJjZXJvcy5maW5jYXdpemFyZC52MS5HZW9tZXRyaWFSZWdpc3Ryb1Jlc3BvbnNlEogBChFMZWVyVmVydGljZXNQaWV6YRI6LnNleHRhbnRlLnRlcmNlcm9zLmZpbmNhd2l6YXJkLnYxLkxlZXJWZXJ0aWNlc1BpZXphUmVxdWVzdBo3LnNleHRhbnRlLnRlcmNlcm9zLmZpbmNhd2l6YXJkLnYxLlZlcnRpY2VzUGllemFSZXNwb25zZRKEAQoTQWdyZWdhclZlcnRpY2VUcmF6bxI8LnNleHRhbnRlLnRlcmNlcm9zLmZpbmNhd2l6YXJkLnYxLkFncmVnYXJWZXJ0aWNlVHJhem9SZXF1ZXN0Gi8uc2V4dGFudGUudGVyY2Vyb3MuZmluY2F3aXphcmQudjEuVHJhem9SZXNwb25zZRKCAQoSUXVpdGFyVmVydGljZVRyYXpvEjsuc2V4dGFudGUudGVyY2Vyb3MuZmluY2F3aXphcmQudjEuUXVpdGFyVmVydGljZVRyYXpvUmVxdWVzdBovLnNleHRhbnRlLnRlcmNlcm9zLmZpbmNhd2l6YXJkLnYxLlRyYXpvUmVzcG9uc2USdgoMTGltcGlhclRyYXpvEjUuc2V4dGFudGUudGVyY2Vyb3MuZmluY2F3aXphcmQudjEuTGltcGlhclRyYXpvUmVxdWVzdBovLnNleHRhbnRlLnRlcmNlcm9zLmZpbmNhd2l6YXJkLnYxLlRyYXpvUmVzcG9uc2VCC6oCCEFwaS5HcnBjYgZwcm90bzM");

/**
 * Registro del que se pide el ticket de mapa.
 *
 * @generated from message sextante.terceros.fincawizard.v1.ObtenerTicketMapaRequest
 */
export type ObtenerTicketMapaRequest = Message<"sextante.terceros.fincawizard.v1.ObtenerTicketMapaRequest"> & {
  /**
   * @generated from field: string registro_id = 1;
   */
  registroId: string;
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.ObtenerTicketMapaRequest.
 * Use `create(ObtenerTicketMapaRequestSchema)` to create a new message.
 */
export const ObtenerTicketMapaRequestSchema: GenMessage<ObtenerTicketMapaRequest> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 0);

/**
 * Ticket de mapa de un registro.
 *
 * @generated from message sextante.terceros.fincawizard.v1.TicketMapaResponse
 */
export type TicketMapaResponse = Message<"sextante.terceros.fincawizard.v1.TicketMapaResponse"> & {
  /**
   * Va como parametro TICKET en cada GetMap de /mapa/registro-finca/wms.
   *
   * @generated from field: string ticket = 1;
   */
  ticket: string;

  /**
   * Vencimiento en Unix ms. La app pide otro antes de esa hora.
   *
   * @generated from field: int64 expira_en = 2;
   */
  expiraEn: bigint;
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.TicketMapaResponse.
 * Use `create(TicketMapaResponseSchema)` to create a new message.
 */
export const TicketMapaResponseSchema: GenMessage<TicketMapaResponse> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 1);

/**
 * Pieza padre que se quiere leer.
 *
 * @generated from message sextante.terceros.fincawizard.v1.LeerPiezaPadreRequest
 */
export type LeerPiezaPadreRequest = Message<"sextante.terceros.fincawizard.v1.LeerPiezaPadreRequest"> & {
  /**
   * @generated from field: string registro_id = 1;
   */
  registroId: string;

  /**
   * Posicion de la pieza en poligonos_padre, 1-based (la misma de AoiPieza.indice).
   *
   * @generated from field: int32 indice = 2;
   */
  indice: number;
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.LeerPiezaPadreRequest.
 * Use `create(LeerPiezaPadreRequestSchema)` to create a new message.
 */
export const LeerPiezaPadreRequestSchema: GenMessage<LeerPiezaPadreRequest> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 2);

/**
 * Lote del registro que se quiere leer.
 *
 * @generated from message sextante.terceros.fincawizard.v1.LeerLoteTemporalRequest
 */
export type LeerLoteTemporalRequest = Message<"sextante.terceros.fincawizard.v1.LeerLoteTemporalRequest"> & {
  /**
   * @generated from field: string registro_id = 1;
   */
  registroId: string;

  /**
   * @generated from field: string lote_id = 2;
   */
  loteId: string;
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.LeerLoteTemporalRequest.
 * Use `create(LeerLoteTemporalRequestSchema)` to create a new message.
 */
export const LeerLoteTemporalRequestSchema: GenMessage<LeerLoteTemporalRequest> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 3);

/**
 * Una geometria del registro.
 *
 * @generated from message sextante.terceros.fincawizard.v1.GeometriaRegistroResponse
 */
export type GeometriaRegistroResponse = Message<"sextante.terceros.fincawizard.v1.GeometriaRegistroResponse"> & {
  /**
   * WKB Polygon. Ausente si no existe (la app sigue con su copia en memoria).
   *
   * @generated from field: optional bytes geometria = 1;
   */
  geometria?: Uint8Array | undefined;
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.GeometriaRegistroResponse.
 * Use `create(GeometriaRegistroResponseSchema)` to create a new message.
 */
export const GeometriaRegistroResponseSchema: GenMessage<GeometriaRegistroResponse> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 4);

/**
 * Pieza padre cuyos vertices se quieren leer.
 *
 * @generated from message sextante.terceros.fincawizard.v1.LeerVerticesPiezaRequest
 */
export type LeerVerticesPiezaRequest = Message<"sextante.terceros.fincawizard.v1.LeerVerticesPiezaRequest"> & {
  /**
   * @generated from field: string registro_id = 1;
   */
  registroId: string;

  /**
   * @generated from field: string poligono_padre_id = 2;
   */
  poligonoPadreId: string;
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.LeerVerticesPiezaRequest.
 * Use `create(LeerVerticesPiezaRequestSchema)` to create a new message.
 */
export const LeerVerticesPiezaRequestSchema: GenMessage<LeerVerticesPiezaRequest> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 5);

/**
 * Un vertice, en grados (EPSG:4326).
 *
 * @generated from message sextante.terceros.fincawizard.v1.VerticeMapa
 */
export type VerticeMapa = Message<"sextante.terceros.fincawizard.v1.VerticeMapa"> & {
  /**
   * @generated from field: double lng = 1;
   */
  lng: number;

  /**
   * @generated from field: double lat = 2;
   */
  lat: number;
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.VerticeMapa.
 * Use `create(VerticeMapaSchema)` to create a new message.
 */
export const VerticeMapaSchema: GenMessage<VerticeMapa> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 6);

/**
 * Vertices de una pieza, en el orden del anillo.
 *
 * @generated from message sextante.terceros.fincawizard.v1.VerticesPiezaResponse
 */
export type VerticesPiezaResponse = Message<"sextante.terceros.fincawizard.v1.VerticesPiezaResponse"> & {
  /**
   * Vacio si la pieza no tiene vertices guardados o tiene menos de 3 (una extraccion a medias).
   *
   * @generated from field: repeated sextante.terceros.fincawizard.v1.VerticeMapa vertices = 1;
   */
  vertices: VerticeMapa[];
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.VerticesPiezaResponse.
 * Use `create(VerticesPiezaResponseSchema)` to create a new message.
 */
export const VerticesPiezaResponseSchema: GenMessage<VerticesPiezaResponse> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 7);

/**
 * Vertice nuevo del trazo en curso.
 *
 * @generated from message sextante.terceros.fincawizard.v1.AgregarVerticeTrazoRequest
 */
export type AgregarVerticeTrazoRequest = Message<"sextante.terceros.fincawizard.v1.AgregarVerticeTrazoRequest"> & {
  /**
   * @generated from field: string registro_id = 1;
   */
  registroId: string;

  /**
   * 1-based: el 1 es el de cierre.
   *
   * @generated from field: int32 orden = 2;
   */
  orden: number;

  /**
   * @generated from field: double lng = 3;
   */
  lng: number;

  /**
   * @generated from field: double lat = 4;
   */
  lat: number;
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.AgregarVerticeTrazoRequest.
 * Use `create(AgregarVerticeTrazoRequestSchema)` to create a new message.
 */
export const AgregarVerticeTrazoRequestSchema: GenMessage<AgregarVerticeTrazoRequest> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 8);

/**
 * Vertice del trazo que se quita.
 *
 * @generated from message sextante.terceros.fincawizard.v1.QuitarVerticeTrazoRequest
 */
export type QuitarVerticeTrazoRequest = Message<"sextante.terceros.fincawizard.v1.QuitarVerticeTrazoRequest"> & {
  /**
   * @generated from field: string registro_id = 1;
   */
  registroId: string;

  /**
   * @generated from field: int32 orden = 2;
   */
  orden: number;
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.QuitarVerticeTrazoRequest.
 * Use `create(QuitarVerticeTrazoRequestSchema)` to create a new message.
 */
export const QuitarVerticeTrazoRequestSchema: GenMessage<QuitarVerticeTrazoRequest> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 9);

/**
 * Registro cuyo trazo se borra.
 *
 * @generated from message sextante.terceros.fincawizard.v1.LimpiarTrazoRequest
 */
export type LimpiarTrazoRequest = Message<"sextante.terceros.fincawizard.v1.LimpiarTrazoRequest"> & {
  /**
   * @generated from field: string registro_id = 1;
   */
  registroId: string;
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.LimpiarTrazoRequest.
 * Use `create(LimpiarTrazoRequestSchema)` to create a new message.
 */
export const LimpiarTrazoRequestSchema: GenMessage<LimpiarTrazoRequest> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 10);

/**
 * Respuesta de las escrituras del trazo: si volvio sin error, ya esta en la base y la app repinta.
 *
 * @generated from message sextante.terceros.fincawizard.v1.TrazoResponse
 */
export type TrazoResponse = Message<"sextante.terceros.fincawizard.v1.TrazoResponse"> & {
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.TrazoResponse.
 * Use `create(TrazoResponseSchema)` to create a new message.
 */
export const TrazoResponseSchema: GenMessage<TrazoResponse> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 11);

/**
 * Un lote del registro en curso (tbl_temp_lotes_finca).
 *
 * @generated from message sextante.terceros.fincawizard.v1.LoteTemporal
 */
export type LoteTemporal = Message<"sextante.terceros.fincawizard.v1.LoteTemporal"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string nombre = 2;
   */
  nombre: string;

  /**
   * Hectareas, calculadas por el servidor con la geometria.
   *
   * @generated from field: double area_has = 3;
   */
  areaHas: number;

  /**
   * Ausente = todavia sin asignar (distinto de false: asignado como no productivo).
   *
   * @generated from field: optional bool area_productiva = 4;
   */
  areaProductiva?: boolean | undefined;

  /**
   * Cultivo, si el lote es productivo.
   *
   * @generated from field: optional string cultivo_id = 5;
   */
  cultivoId?: string | undefined;

  /**
   * Cobertura (catalogo de lotes no productivos), si el lote no es productivo.
   *
   * @generated from field: optional string cobertura_id = 6;
   */
  coberturaId?: string | undefined;

  /**
   * WKB Polygon.
   *
   * @generated from field: bytes geometria = 7;
   */
  geometria: Uint8Array;
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.LoteTemporal.
 * Use `create(LoteTemporalSchema)` to create a new message.
 */
export const LoteTemporalSchema: GenMessage<LoteTemporal> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 12);

/**
 * El registro de finca en curso (tbl_temp_crear_finca) con sus lotes: lo que la app necesita para retomar
 * el asistente donde quedo.
 *
 * @generated from message sextante.terceros.fincawizard.v1.RegistroTemporal
 */
export type RegistroTemporal = Message<"sextante.terceros.fincawizard.v1.RegistroTemporal"> & {
  /**
   * Es el registro_id que piden los demas rpc.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Finca a completar (modo completar); ausente en un alta nueva.
   *
   * @generated from field: optional string finca_id = 2;
   */
  fincaId?: string | undefined;

  /**
   * @generated from field: string nombre = 3;
   */
  nombre: string;

  /**
   * 0 = Agricultura, 1 = Ganaderia.
   *
   * @generated from field: int32 tipo = 4;
   */
  tipo: number;

  /**
   * Ultimo paso confirmado, de 1 a 5: la app retoma en el siguiente.
   *
   * @generated from field: int32 ultimo_paso = 5;
   */
  ultimoPaso: number;

  /**
   * "Dibujado sobre mapa" | "Archivo importado"; ausente hasta confirmar el paso 2.
   *
   * @generated from field: optional string fuente = 6;
   */
  fuente?: string | undefined;

  /**
   * WKB Polygon; ausente hasta confirmar el paso 3.
   *
   * @generated from field: optional bytes aoi_satelite = 7;
   */
  aoiSatelite?: Uint8Array | undefined;

  /**
   * @generated from field: repeated sextante.terceros.fincawizard.v1.LoteTemporal lotes = 8;
   */
  lotes: LoteTemporal[];

  /**
   * true = este registro esta REORGANIZANDO una finca que ya existe ("Editar finca"), no creando una.
   * El wizard lo abre en el paso 4 y no lo deja volver a los pasos 1-3: el area no se toca desde ahi.
   *
   * @generated from field: bool es_edicion = 10;
   */
  esEdicion: boolean;

  /**
   * Las piezas del paso 3 TAL CUAL las dibujo (o importo) el usuario, una WKB Polygon cada una, antes
   * de unirse en aoi_satelite. Es lo que el paso 3 restaura al retomarse: la union es irreversible, de
   * un perimetro unico no se puede volver a sacar de que poligonos salio. Vacio en los registros
   * anteriores a esta columna (ahi el cliente cae en su reconstruccion vieja a partir de los lotes) y
   * mientras el registro no tenga area.
   *
   * @generated from field: repeated bytes poligonos_padre = 9;
   */
  poligonosPadre: Uint8Array[];

  /**
   * El id de cada pieza en tbl_temp_poligonos_padre, en la MISMA posicion que poligonos_padre.
   * Es el id estable con el que el paso 3 le pide a GeoServer los vertices de una pieza: una pieza
   * dentro del MultiPolygon solo se puede nombrar por su posicion, y esa posicion se corre cuando el
   * usuario borra otra. Vacio en los registros anteriores a estas tablas.
   *
   * @generated from field: repeated string poligonos_padre_ids = 11;
   */
  poligonosPadreIds: string[];

  /**
   * El archivo KML/KMZ que origino el area, si vino de uno (ver ImportarArchivoKml): su nombre tal
   * como lo eligio el usuario y el aviso de lo que se descarto al depurarlo. Ausentes por el camino
   * "Dibujado sobre mapa" y en los registros anteriores a estas columnas. La URL del blob NO viaja:
   * el cliente no tiene nada que hacer con ella -el que lee el archivo es el servidor- y es una ruta
   * de storage que no hace falta exponer.
   *
   * @generated from field: optional string archivo_nombre = 12;
   */
  archivoNombre?: string | undefined;

  /**
   * @generated from field: optional string archivo_aviso_depuracion = 13;
   */
  archivoAvisoDepuracion?: string | undefined;
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.RegistroTemporal.
 * Use `create(RegistroTemporalSchema)` to create a new message.
 */
export const RegistroTemporalSchema: GenMessage<RegistroTemporal> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 13);

/**
 * Sin datos: el cliente sale de la sesion.
 *
 * @generated from message sextante.terceros.fincawizard.v1.ObtenerRegistroEnCursoRequest
 */
export type ObtenerRegistroEnCursoRequest = Message<"sextante.terceros.fincawizard.v1.ObtenerRegistroEnCursoRequest"> & {
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.ObtenerRegistroEnCursoRequest.
 * Use `create(ObtenerRegistroEnCursoRequestSchema)` to create a new message.
 */
export const ObtenerRegistroEnCursoRequestSchema: GenMessage<ObtenerRegistroEnCursoRequest> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 14);

/**
 * El registro en curso del cliente, si tiene uno.
 *
 * @generated from message sextante.terceros.fincawizard.v1.ObtenerRegistroEnCursoResponse
 */
export type ObtenerRegistroEnCursoResponse = Message<"sextante.terceros.fincawizard.v1.ObtenerRegistroEnCursoResponse"> & {
  /**
   * Sin valor si el cliente no tiene un registro en curso.
   *
   * @generated from field: sextante.terceros.fincawizard.v1.RegistroTemporal registro = 1;
   */
  registro?: RegistroTemporal | undefined;
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.ObtenerRegistroEnCursoResponse.
 * Use `create(ObtenerRegistroEnCursoResponseSchema)` to create a new message.
 */
export const ObtenerRegistroEnCursoResponseSchema: GenMessage<ObtenerRegistroEnCursoResponse> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 15);

/**
 * Finca completa del cliente que se va a reorganizar.
 *
 * @generated from message sextante.terceros.fincawizard.v1.IniciarEdicionFincaRequest
 */
export type IniciarEdicionFincaRequest = Message<"sextante.terceros.fincawizard.v1.IniciarEdicionFincaRequest"> & {
  /**
   * @generated from field: string finca_id = 1;
   */
  fincaId: string;
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.IniciarEdicionFincaRequest.
 * Use `create(IniciarEdicionFincaRequestSchema)` to create a new message.
 */
export const IniciarEdicionFincaRequestSchema: GenMessage<IniciarEdicionFincaRequest> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 16);

/**
 * Datos del paso 1.
 *
 * @generated from message sextante.terceros.fincawizard.v1.GuardarDatosBasicosRequest
 */
export type GuardarDatosBasicosRequest = Message<"sextante.terceros.fincawizard.v1.GuardarDatosBasicosRequest"> & {
  /**
   * Ausente para crear el registro.
   *
   * @generated from field: optional string registro_id = 1;
   */
  registroId?: string | undefined;

  /**
   * Modo completar: finca existente sin AOI/lotes. Solo se lee al crear.
   *
   * @generated from field: optional string finca_id = 2;
   */
  fincaId?: string | undefined;

  /**
   * Se ignora en modo completar: queda el nombre que la finca ya tiene.
   *
   * @generated from field: string nombre = 3;
   */
  nombre: string;

  /**
   * 0 = Agricultura, 1 = Ganaderia.
   *
   * @generated from field: int32 tipo = 4;
   */
  tipo: number;
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.GuardarDatosBasicosRequest.
 * Use `create(GuardarDatosBasicosRequestSchema)` to create a new message.
 */
export const GuardarDatosBasicosRequestSchema: GenMessage<GuardarDatosBasicosRequest> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 17);

/**
 * Fuente del area elegida en el paso 2.
 *
 * @generated from message sextante.terceros.fincawizard.v1.GuardarFuenteRequest
 */
export type GuardarFuenteRequest = Message<"sextante.terceros.fincawizard.v1.GuardarFuenteRequest"> & {
  /**
   * @generated from field: string registro_id = 1;
   */
  registroId: string;

  /**
   * "Dibujado sobre mapa" o "Archivo importado"; otro valor se rechaza con FUENTE_INVALIDA.
   *
   * @generated from field: string fuente = 2;
   */
  fuente: string;
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.GuardarFuenteRequest.
 * Use `create(GuardarFuenteRequestSchema)` to create a new message.
 */
export const GuardarFuenteRequestSchema: GenMessage<GuardarFuenteRequest> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 18);

/**
 * Resultado de GuardarFuente.
 *
 * @generated from message sextante.terceros.fincawizard.v1.GuardarFuenteResponse
 */
export type GuardarFuenteResponse = Message<"sextante.terceros.fincawizard.v1.GuardarFuenteResponse"> & {
  /**
   * true si el cambio de fuente descarto un AOI/lotes ya guardados.
   *
   * @generated from field: bool datos_descartados = 1;
   */
  datosDescartados: boolean;
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.GuardarFuenteResponse.
 * Use `create(GuardarFuenteResponseSchema)` to create a new message.
 */
export const GuardarFuenteResponseSchema: GenMessage<GuardarFuenteResponse> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 19);

/**
 * Piezas del area del registro (pasos 2, 3 y 4).
 *
 * @generated from message sextante.terceros.fincawizard.v1.GuardarAoiRequest
 */
export type GuardarAoiRequest = Message<"sextante.terceros.fincawizard.v1.GuardarAoiRequest"> & {
  /**
   * @generated from field: string registro_id = 1;
   */
  registroId: string;

  /**
   * IGNORADO desde 2026-10-09: el perimetro lo calcula el servidor con poligonos_padre. El campo se
   * conserva para no romper el contrato; el cliente lo manda vacio.
   *
   * @generated from field: bytes aoi_satelite = 2 [deprecated = true];
   * @deprecated
   */
  aoiSatelite: Uint8Array;

  /**
   * Las piezas del area, una WKB Polygon cada una (ver RegistroTemporal.poligonos_padre). Son lo UNICO
   * que viaja: de aca sale el perimetro y de aca salen las filas con id. Cada pieza se valida por su
   * cuenta —una pieza en moño puede fundirse en la union y dar un resultado que pasa el IsValid—.
   * VACIO = el usuario borro todos los poligonos: se quita el area.
   *
   * @generated from field: repeated bytes poligonos_padre = 3;
   */
  poligonosPadre: Uint8Array[];

  /**
   * true = NO bajar ultimo_paso aunque el area cambie. Lo manda el paso 4 cuando el area cambio COMO
   * CONSECUENCIA de editar los lotes (mover un vertice, borrar un lote): ahi el padre se recalcula a
   * partir de los lotes, asi que ya estan alineados y no hay nada que volver a confirmar en el paso 3
   * — devolver al usuario al paso 2 en medio de la edicion seria absurdo.
   *
   * @generated from field: bool conservar_paso = 4;
   */
  conservarPaso: boolean;

  /**
   * El id que el cliente ya tiene para cada pieza, en la MISMA posicion que poligonos_padre.
   * Cadena vacia = pieza nueva, el servidor le asigna uno. Es lo que mantiene el id ESTABLE
   * mientras se le editan los vertices: sin esto el servidor no podria distinguir una pieza
   * que cambio de forma de una pieza nueva, y cada vertice movido estrenaria id — dejando al
   * cliente pidiendo los vertices de una fila que acaba de quedar eliminada.
   * Vacio entero = el cliente no conoce ningun id (restauracion vieja): se reasignan todos.
   *
   * @generated from field: repeated string poligonos_padre_ids = 5;
   */
  poligonosPadreIds: string[];
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.GuardarAoiRequest.
 * Use `create(GuardarAoiRequestSchema)` to create a new message.
 */
export const GuardarAoiRequestSchema: GenMessage<GuardarAoiRequest> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 20);

/**
 * Resultado de GuardarAoi.
 *
 * @generated from message sextante.terceros.fincawizard.v1.GuardarAoiResponse
 */
export type GuardarAoiResponse = Message<"sextante.terceros.fincawizard.v1.GuardarAoiResponse"> & {
  /**
   * true si se borraron los lotes: solo pasa al quitar el area entera (bytes vacios).
   *
   * @generated from field: bool lotes_eliminados = 1;
   */
  lotesEliminados: boolean;

  /**
   * true si el area es distinta de la guardada (el avance volvio al paso 2).
   *
   * @generated from field: bool area_cambio = 2;
   */
  areaCambio: boolean;

  /**
   * El id de cada pieza guardada, en la MISMA posicion que llegaron en el request. El cliente
   * los adopta: a partir de aca los manda de vuelta en cada guardado y los usa para pedirle a
   * GeoServer los vertices de la pieza que esta editando. Vacio cuando se quito el area.
   *
   * @generated from field: repeated string poligonos_padre_ids = 3;
   */
  poligonosPadreIds: string[];
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.GuardarAoiResponse.
 * Use `create(GuardarAoiResponseSchema)` to create a new message.
 */
export const GuardarAoiResponseSchema: GenMessage<GuardarAoiResponse> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 21);

/**
 * Lote a insertar. La asignacion es opcional: los lotes recien cortados nacen sin asignar, pero una
 * resincronizacion completa conserva la que ya tenian.
 *
 * @generated from message sextante.terceros.fincawizard.v1.LoteNuevo
 */
export type LoteNuevo = Message<"sextante.terceros.fincawizard.v1.LoteNuevo"> & {
  /**
   * @generated from field: string nombre = 1;
   */
  nombre: string;

  /**
   * WKB Polygon.
   *
   * @generated from field: bytes geometria = 2;
   */
  geometria: Uint8Array;

  /**
   * @generated from field: optional bool area_productiva = 3;
   */
  areaProductiva?: boolean | undefined;

  /**
   * @generated from field: optional string cultivo_id = 4;
   */
  cultivoId?: string | undefined;

  /**
   * @generated from field: optional string cobertura_id = 5;
   */
  coberturaId?: string | undefined;
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.LoteNuevo.
 * Use `create(LoteNuevoSchema)` to create a new message.
 */
export const LoteNuevoSchema: GenMessage<LoteNuevo> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 22);

/**
 * Poligono del paso 3.
 *
 * @generated from message sextante.terceros.fincawizard.v1.PiezaAoi
 */
export type PiezaAoi = Message<"sextante.terceros.fincawizard.v1.PiezaAoi"> & {
  /**
   * WKB Polygon.
   *
   * @generated from field: bytes geometria = 1;
   */
  geometria: Uint8Array;

  /**
   * Nombre para el lote si la pieza se agrega (ej. el del Placemark del KML).
   *
   * @generated from field: optional string nombre = 2;
   */
  nombre?: string | undefined;

  /**
   * true si la pieza es nueva o se modifico con la herramienta Editar; false si es un poligono
   * restaurado sin tocar.
   *
   * @generated from field: bool modificada = 3;
   */
  modificada: boolean;
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.PiezaAoi.
 * Use `create(PiezaAoiSchema)` to create a new message.
 */
export const PiezaAoiSchema: GenMessage<PiezaAoi> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 23);

/**
 * Los poligonos del mapa al pulsar "Continuar" en el paso 3.
 *
 * @generated from message sextante.terceros.fincawizard.v1.ConfirmarPiezasRequest
 */
export type ConfirmarPiezasRequest = Message<"sextante.terceros.fincawizard.v1.ConfirmarPiezasRequest"> & {
  /**
   * @generated from field: string registro_id = 1;
   */
  registroId: string;

  /**
   * @generated from field: repeated sextante.terceros.fincawizard.v1.PiezaAoi piezas = 2;
   */
  piezas: PiezaAoi[];
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.ConfirmarPiezasRequest.
 * Use `create(ConfirmarPiezasRequestSchema)` to create a new message.
 */
export const ConfirmarPiezasRequestSchema: GenMessage<ConfirmarPiezasRequest> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 24);

/**
 * Archivo KML/KMZ ya subido al blob, para importarlo al registro.
 *
 * @generated from message sextante.terceros.fincawizard.v1.ImportarArchivoKmlRequest
 */
export type ImportarArchivoKmlRequest = Message<"sextante.terceros.fincawizard.v1.ImportarArchivoKmlRequest"> & {
  /**
   * @generated from field: string registro_id = 1;
   */
  registroId: string;

  /**
   * URL permanente del blob (lo que devuelve StorageService.GetSasUploadUrl como blob_url). Si trae
   * token SAS se ignora: la descarga se autentica con la clave de la cuenta.
   *
   * @generated from field: string blob_url = 2;
   */
  blobUrl: string;

  /**
   * Nombre del archivo tal como lo eligio el usuario (el blob vive bajo una ruta con GUID).
   *
   * @generated from field: string nombre_archivo = 3;
   */
  nombreArchivo: string;
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.ImportarArchivoKmlRequest.
 * Use `create(ImportarArchivoKmlRequestSchema)` to create a new message.
 */
export const ImportarArchivoKmlRequestSchema: GenMessage<ImportarArchivoKmlRequest> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 25);

/**
 * Resultado de ImportarArchivoKml.
 *
 * @generated from message sextante.terceros.fincawizard.v1.ImportarArchivoKmlResponse
 */
export type ImportarArchivoKmlResponse = Message<"sextante.terceros.fincawizard.v1.ImportarArchivoKmlResponse"> & {
  /**
   * Los poligonos padre del archivo, una WKB Polygon cada uno: cada grupo de poligonos que se tocan,
   * fundido en su perimetro exterior. Es lo que el paso 3 muestra; el cliente los une con puentes para
   * obtener el area y los manda de vuelta por GuardarAoi (que es el que les asigna id).
   *
   * @generated from field: repeated bytes poligonos_padre = 1;
   */
  poligonosPadre: Uint8Array[];

  /**
   * Cuantos lotes quedaron guardados (los poligonos del archivo ya depurados). No viajan las
   * geometrias: el paso 3 no las muestra y el paso 4 las pide a GeoServer/ObtenerRegistroEnCurso.
   *
   * @generated from field: int32 lotes_guardados = 2;
   */
  lotesGuardados: number;

  /**
   * Que se descarto al depurar, ya redactado en espanol. Vacio si no se descarto nada.
   *
   * @generated from field: string aviso_depuracion = 3;
   */
  avisoDepuracion: string;
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.ImportarArchivoKmlResponse.
 * Use `create(ImportarArchivoKmlResponseSchema)` to create a new message.
 */
export const ImportarArchivoKmlResponseSchema: GenMessage<ImportarArchivoKmlResponse> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 26);

/**
 * Lotes que reemplazan a todos los del registro.
 *
 * @generated from message sextante.terceros.fincawizard.v1.IniciarLotesRequest
 */
export type IniciarLotesRequest = Message<"sextante.terceros.fincawizard.v1.IniciarLotesRequest"> & {
  /**
   * @generated from field: string registro_id = 1;
   */
  registroId: string;

  /**
   * @generated from field: repeated sextante.terceros.fincawizard.v1.LoteNuevo lotes = 2;
   */
  lotes: LoteNuevo[];
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.IniciarLotesRequest.
 * Use `create(IniciarLotesRequestSchema)` to create a new message.
 */
export const IniciarLotesRequestSchema: GenMessage<IniciarLotesRequest> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 27);

/**
 * Geometria de un lote, o de una pieza del paso 3, con su id.
 *
 * @generated from message sextante.terceros.fincawizard.v1.LoteGeometria
 */
export type LoteGeometria = Message<"sextante.terceros.fincawizard.v1.LoteGeometria"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * WKB Polygon.
   *
   * @generated from field: bytes geometria = 2;
   */
  geometria: Uint8Array;
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.LoteGeometria.
 * Use `create(LoteGeometriaSchema)` to create a new message.
 */
export const LoteGeometriaSchema: GenMessage<LoteGeometria> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 28);

/**
 * Una operacion sobre UN vertice. Las tres formas se distinguen por que campos vienen:
 * 
 *   mover    -> origen + destino
 *   quitar   -> origen, sin destino
 *   insertar -> lote_id + indice_arista + destino (se inserta en el medio de esa arista y se mueve
 *               al destino en una sola operacion, que es como lo vive el usuario: agarra el punto
 *               medio y lo arrastra)
 * 
 * El vertice se nombra por su POSICION y no por un id: no hay tabla de vertices de lote, y son las
 * coordenadas —redondeadas a los mismos 7 decimales con que se guarda todo— las que permiten
 * reconocerlo en varios lotes a la vez.
 *
 * @generated from message sextante.terceros.fincawizard.v1.EditarVerticeLoteRequest
 */
export type EditarVerticeLoteRequest = Message<"sextante.terceros.fincawizard.v1.EditarVerticeLoteRequest"> & {
  /**
   * @generated from field: string registro_id = 1;
   */
  registroId: string;

  /**
   * WKB Point. Ausente al insertar.
   *
   * @generated from field: optional bytes origen = 2;
   */
  origen?: Uint8Array | undefined;

  /**
   * WKB Point. Ausente al quitar.
   *
   * @generated from field: optional bytes destino = 3;
   */
  destino?: Uint8Array | undefined;

  /**
   * Solo al insertar: en que lote y en que arista de su anillo exterior.
   *
   * @generated from field: optional string lote_id = 4;
   */
  loteId?: string | undefined;

  /**
   * @generated from field: optional int32 indice_arista = 5;
   */
  indiceArista?: number | undefined;
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.EditarVerticeLoteRequest.
 * Use `create(EditarVerticeLoteRequestSchema)` to create a new message.
 */
export const EditarVerticeLoteRequestSchema: GenMessage<EditarVerticeLoteRequest> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 29);

/**
 * Resultado de EditarVerticeLote.
 *
 * @generated from message sextante.terceros.fincawizard.v1.EditarVerticeLoteResponse
 */
export type EditarVerticeLoteResponse = Message<"sextante.terceros.fincawizard.v1.EditarVerticeLoteResponse"> & {
  /**
   * TODOS los lotes del registro, ya actualizados. Una sola operacion puede cambiar la geometria de
   * varios lotes a la vez, que es justamente lo topologico.
   *
   * @generated from field: repeated sextante.terceros.fincawizard.v1.LoteTemporal lotes = 1;
   */
  lotes: LoteTemporal[];
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.EditarVerticeLoteResponse.
 * Use `create(EditarVerticeLoteResponseSchema)` to create a new message.
 */
export const EditarVerticeLoteResponseSchema: GenMessage<EditarVerticeLoteResponse> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 30);

/**
 * Una operacion sobre UN vertice de una pieza del paso 3. Las tres formas se distinguen por que
 * campos vienen, igual que en EditarVerticeLoteRequest:
 * 
 *   mover    -> origen + destino
 *   quitar   -> origen, sin destino
 *   insertar -> poligono_padre_id + indice_arista + destino
 * 
 * El vertice se nombra por sus COORDENADAS (redondeadas a los mismos 7 decimales con que se guarda
 * todo) y no por el id de su fila en tbl_temp_vertices_dibujo: esa tabla es un reflejo de la
 * geometria —la reescribe el servidor cada vez que la pieza cambia de forma—, asi que su id no
 * sobrevive a la edicion. Las coordenadas si, y ademas son las que permiten reconocer el mismo
 * vertice en dos piezas que se tocan.
 *
 * @generated from message sextante.terceros.fincawizard.v1.EditarVerticePoligonoPadreRequest
 */
export type EditarVerticePoligonoPadreRequest = Message<"sextante.terceros.fincawizard.v1.EditarVerticePoligonoPadreRequest"> & {
  /**
   * @generated from field: string registro_id = 1;
   */
  registroId: string;

  /**
   * WKB Point. Ausente al insertar.
   *
   * @generated from field: optional bytes origen = 2;
   */
  origen?: Uint8Array | undefined;

  /**
   * WKB Point. Ausente al quitar.
   *
   * @generated from field: optional bytes destino = 3;
   */
  destino?: Uint8Array | undefined;

  /**
   * Solo al insertar: en que pieza y en que arista de su anillo exterior.
   *
   * @generated from field: optional string poligono_padre_id = 4;
   */
  poligonoPadreId?: string | undefined;

  /**
   * @generated from field: optional int32 indice_arista = 5;
   */
  indiceArista?: number | undefined;
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.EditarVerticePoligonoPadreRequest.
 * Use `create(EditarVerticePoligonoPadreRequestSchema)` to create a new message.
 */
export const EditarVerticePoligonoPadreRequestSchema: GenMessage<EditarVerticePoligonoPadreRequest> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 31);

/**
 * Resultado de EditarVerticePoligonoPadre.
 *
 * @generated from message sextante.terceros.fincawizard.v1.EditarVerticePoligonoPadreResponse
 */
export type EditarVerticePoligonoPadreResponse = Message<"sextante.terceros.fincawizard.v1.EditarVerticePoligonoPadreResponse"> & {
  /**
   * Solo las piezas que CAMBIARON, con su geometria nueva. Normalmente una; son varias cuando el
   * vertice lo comparten dos piezas que se tocan (ahi se mueve en las dos, que es lo que evita que
   * entre ellas quede una rendija).
   *
   * @generated from field: repeated sextante.terceros.fincawizard.v1.LoteGeometria piezas = 1;
   */
  piezas: LoteGeometria[];
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.EditarVerticePoligonoPadreResponse.
 * Use `create(EditarVerticePoligonoPadreResponseSchema)` to create a new message.
 */
export const EditarVerticePoligonoPadreResponseSchema: GenMessage<EditarVerticePoligonoPadreResponse> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 32);

/**
 * Los dos lotes que se quieren unir.
 *
 * @generated from message sextante.terceros.fincawizard.v1.UnirLotesRequest
 */
export type UnirLotesRequest = Message<"sextante.terceros.fincawizard.v1.UnirLotesRequest"> & {
  /**
   * @generated from field: string registro_id = 1;
   */
  registroId: string;

  /**
   * Los dos lotes a unir. El orden no importa.
   *
   * @generated from field: string lote_id_a = 2;
   */
  loteIdA: string;

  /**
   * @generated from field: string lote_id_b = 3;
   */
  loteIdB: string;
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.UnirLotesRequest.
 * Use `create(UnirLotesRequestSchema)` to create a new message.
 */
export const UnirLotesRequestSchema: GenMessage<UnirLotesRequest> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 33);

/**
 * Resultado de UnirLotes.
 *
 * @generated from message sextante.terceros.fincawizard.v1.UnirLotesResponse
 */
export type UnirLotesResponse = Message<"sextante.terceros.fincawizard.v1.UnirLotesResponse"> & {
  /**
   * TODOS los lotes del registro, ya actualizados — mismo criterio que DividirLoteResponse: el
   * cliente se queda con lo que hay en la base y no con su memoria mas un parche.
   *
   * @generated from field: repeated sextante.terceros.fincawizard.v1.LoteTemporal lotes = 1;
   */
  lotes: LoteTemporal[];

  /**
   * El id del lote que resulto de la union.
   *
   * @generated from field: string lote_unido_id = 2;
   */
  loteUnidoId: string;
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.UnirLotesResponse.
 * Use `create(UnirLotesResponseSchema)` to create a new message.
 */
export const UnirLotesResponseSchema: GenMessage<UnirLotesResponse> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 34);

/**
 * Resultado de DividirLote.
 *
 * @generated from message sextante.terceros.fincawizard.v1.DividirLoteResponse
 */
export type DividirLoteResponse = Message<"sextante.terceros.fincawizard.v1.DividirLoteResponse"> & {
  /**
   * TODOS los lotes del registro, ya actualizados. No alcanza con devolver las dos mitades: el corte
   * puede insertarle un vertice al borde de un vecino (ver LoteSplitGeometria.SellarBordes), asi que
   * el cliente tiene que quedar con lo que hay en la base y no con su memoria mas un parche.
   *
   * @generated from field: repeated sextante.terceros.fincawizard.v1.LoteTemporal lotes = 1;
   */
  lotes: LoteTemporal[];

  /**
   * Los ids de las DOS mitades que salieron del corte, en el orden en que quedaron (primero la de
   * mayor area).
   * 
   * Es lo que le permite al cliente volver a emparejarlas para el atajo de "fusionar de vuelta"
   * (getFusionCandidate). Ese parentesco NO se guarda: tbl_temp_lotes_finca no tiene columna de lote
   * de origen —la tiene el lote DEFINITIVO de terceros, no el temporal— y nunca la tuvo, asi que
   * antes de este rpc tambien era una relacion que solo vivia en la memoria del navegador.
   *
   * @generated from field: repeated string mitades_ids = 2;
   */
  mitadesIds: string[];
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.DividirLoteResponse.
 * Use `create(DividirLoteResponseSchema)` to create a new message.
 */
export const DividirLoteResponseSchema: GenMessage<DividirLoteResponse> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 35);

/**
 * Lote a dividir y la linea de corte.
 *
 * @generated from message sextante.terceros.fincawizard.v1.DividirLoteRequest
 */
export type DividirLoteRequest = Message<"sextante.terceros.fincawizard.v1.DividirLoteRequest"> & {
  /**
   * @generated from field: string registro_id = 1;
   */
  registroId: string;

  /**
   * El lote que el usuario toco para dividir. Es el primer candidato del corte; si esa linea no lo
   * parte, se prueban los demas lotes que cruza, en el orden de siempre (el de la interseccion mas
   * temprana a lo largo de la linea).
   *
   * @generated from field: string lote_id = 2;
   */
  loteId: string;

  /**
   * WKB LineString con la linea tal como quedo dibujada, SIN prolongar: los 10 cm de extension de
   * cada extremo los agrega el servidor, que es donde vive esa regla.
   *
   * @generated from field: bytes linea = 3;
   */
  linea: Uint8Array;
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.DividirLoteRequest.
 * Use `create(DividirLoteRequestSchema)` to create a new message.
 */
export const DividirLoteRequestSchema: GenMessage<DividirLoteRequest> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 36);

/**
 * Trazo en curso que se quiere autocerrar.
 *
 * @generated from message sextante.terceros.fincawizard.v1.ValidarAutocierreLoteRequest
 */
export type ValidarAutocierreLoteRequest = Message<"sextante.terceros.fincawizard.v1.ValidarAutocierreLoteRequest"> & {
  /**
   * @generated from field: string registro_id = 1;
   */
  registroId: string;

  /**
   * WKB LineString: el trazo tal como va hasta ahora, con el punto recien puesto incluido. Se evalua
   * como ABIERTO (si estuviera cerrado no hay nada que autocerrar).
   *
   * @generated from field: bytes trazo = 2;
   */
  trazo: Uint8Array;
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.ValidarAutocierreLoteRequest.
 * Use `create(ValidarAutocierreLoteRequestSchema)` to create a new message.
 */
export const ValidarAutocierreLoteRequestSchema: GenMessage<ValidarAutocierreLoteRequest> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 37);

/**
 * Si el trazo se puede autocerrar y cuantas hectareas tendria el lote.
 *
 * @generated from message sextante.terceros.fincawizard.v1.ValidarAutocierreLoteResponse
 */
export type ValidarAutocierreLoteResponse = Message<"sextante.terceros.fincawizard.v1.ValidarAutocierreLoteResponse"> & {
  /**
   * true = con este trazo se puede cerrar un lote valido contra un borde existente.
   *
   * @generated from field: bool valido = 1;
   */
  valido: boolean;

  /**
   * Por que no se puede, si valido es false. Es para dejarlo en el log o en un aviso suave; el
   * cliente NO interrumpe el dibujo con esto — un trazo que todavia no cierra es un estado normal
   * mientras se dibuja, no un error.
   *
   * @generated from field: string motivo = 2;
   */
  motivo: string;

  /**
   * Hectareas que tendria el lote si se confirma. Va en el modal de confirmacion: es lo unico que le
   * dice al usuario QUE va a crear antes de aceptar.
   *
   * @generated from field: double area_has = 3;
   */
  areaHas: number;
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.ValidarAutocierreLoteResponse.
 * Use `create(ValidarAutocierreLoteResponseSchema)` to create a new message.
 */
export const ValidarAutocierreLoteResponseSchema: GenMessage<ValidarAutocierreLoteResponse> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 38);

/**
 * Trazo del lote nuevo.
 *
 * @generated from message sextante.terceros.fincawizard.v1.DibujarLoteRequest
 */
export type DibujarLoteRequest = Message<"sextante.terceros.fincawizard.v1.DibujarLoteRequest"> & {
  /**
   * @generated from field: string registro_id = 1;
   */
  registroId: string;

  /**
   * WKB LineString con los vertices que el usuario clickeo, en orden y ya redondeados a 7 decimales.
   * 
   * Va como LineString y no como Polygon a proposito: un trazo abierto —el que se autocierra contra
   * el borde del padre— no es un anillo, y mandar las dos formas por el mismo campo evita que el
   * cliente tenga que decidir cual es cual. Si el primer punto repite el ultimo, el trazo esta
   * cerrado; si no, se intenta el autocierre.
   *
   * @generated from field: bytes trazo = 2;
   */
  trazo: Uint8Array;
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.DibujarLoteRequest.
 * Use `create(DibujarLoteRequestSchema)` to create a new message.
 */
export const DibujarLoteRequestSchema: GenMessage<DibujarLoteRequest> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 39);

/**
 * Resultado de DibujarLote.
 *
 * @generated from message sextante.terceros.fincawizard.v1.DibujarLoteResponse
 */
export type DibujarLoteResponse = Message<"sextante.terceros.fincawizard.v1.DibujarLoteResponse"> & {
  /**
   * TODOS los lotes del registro, ya actualizados — mismo criterio que DividirLoteResponse.
   *
   * @generated from field: repeated sextante.terceros.fincawizard.v1.LoteTemporal lotes = 1;
   */
  lotes: LoteTemporal[];

  /**
   * El id del lote que se acaba de crear.
   *
   * @generated from field: string lote_nuevo_id = 2;
   */
  loteNuevoId: string;

  /**
   * true si el contorno se completo con el borde del padre (trazo abierto). Lo usa el cliente solo
   * para el aviso: con autocierre el lote que aparece tiene mas vertices de los que el usuario
   * clickeo, y conviene decirlo.
   *
   * @generated from field: bool autocerrado = 3;
   */
  autocerrado: boolean;
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.DibujarLoteResponse.
 * Use `create(DibujarLoteResponseSchema)` to create a new message.
 */
export const DibujarLoteResponseSchema: GenMessage<DibujarLoteResponse> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 40);

/**
 * Cambio de lotes del paso 4: los que se borran, los que se agregan y los vecinos que cambian de forma.
 *
 * @generated from message sextante.terceros.fincawizard.v1.ReemplazarLotesRequest
 */
export type ReemplazarLotesRequest = Message<"sextante.terceros.fincawizard.v1.ReemplazarLotesRequest"> & {
  /**
   * @generated from field: string registro_id = 1;
   */
  registroId: string;

  /**
   * Ids de los lotes que se borran.
   *
   * @generated from field: repeated string eliminar_ids = 2;
   */
  eliminarIds: string[];

  /**
   * Lotes nuevos; la respuesta devuelve sus ids en este mismo orden.
   *
   * @generated from field: repeated sextante.terceros.fincawizard.v1.LoteNuevo agregar = 3;
   */
  agregar: LoteNuevo[];

  /**
   * Vecinos a los que el corte les inserto un vertice en el borde comun.
   *
   * @generated from field: repeated sextante.terceros.fincawizard.v1.LoteGeometria actualizar_geometria = 4;
   */
  actualizarGeometria: LoteGeometria[];
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.ReemplazarLotesRequest.
 * Use `create(ReemplazarLotesRequestSchema)` to create a new message.
 */
export const ReemplazarLotesRequestSchema: GenMessage<ReemplazarLotesRequest> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 41);

/**
 * Los lotes insertados, en el MISMO orden en que llegaron (el cliente asocia cada id por posicion).
 *
 * @generated from message sextante.terceros.fincawizard.v1.LotesTemporalesResponse
 */
export type LotesTemporalesResponse = Message<"sextante.terceros.fincawizard.v1.LotesTemporalesResponse"> & {
  /**
   * @generated from field: repeated sextante.terceros.fincawizard.v1.LoteTemporal lotes = 1;
   */
  lotes: LoteTemporal[];
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.LotesTemporalesResponse.
 * Use `create(LotesTemporalesResponseSchema)` to create a new message.
 */
export const LotesTemporalesResponseSchema: GenMessage<LotesTemporalesResponse> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 42);

/**
 * Asignacion de un lote: productivo con su cultivo, o no productivo con su cobertura.
 *
 * @generated from message sextante.terceros.fincawizard.v1.AsignacionLote
 */
export type AsignacionLote = Message<"sextante.terceros.fincawizard.v1.AsignacionLote"> & {
  /**
   * Ausente = sin asignar.
   *
   * @generated from field: optional bool area_productiva = 1;
   */
  areaProductiva?: boolean | undefined;

  /**
   * @generated from field: optional string cultivo_id = 2;
   */
  cultivoId?: string | undefined;

  /**
   * @generated from field: optional string cobertura_id = 3;
   */
  coberturaId?: string | undefined;
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.AsignacionLote.
 * Use `create(AsignacionLoteSchema)` to create a new message.
 */
export const AsignacionLoteSchema: GenMessage<AsignacionLote> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 43);

/**
 * Cambio de un lote: nombre, asignacion o las dos cosas.
 *
 * @generated from message sextante.terceros.fincawizard.v1.LoteActualizacion
 */
export type LoteActualizacion = Message<"sextante.terceros.fincawizard.v1.LoteActualizacion"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Presente = renombrar.
   *
   * @generated from field: optional string nombre = 2;
   */
  nombre?: string | undefined;

  /**
   * Presente = reemplazar la asignacion completa.
   *
   * @generated from field: sextante.terceros.fincawizard.v1.AsignacionLote asignacion = 3;
   */
  asignacion?: AsignacionLote | undefined;
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.LoteActualizacion.
 * Use `create(LoteActualizacionSchema)` to create a new message.
 */
export const LoteActualizacionSchema: GenMessage<LoteActualizacion> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 44);

/**
 * Cambios de nombre o asignacion de varios lotes del registro.
 *
 * @generated from message sextante.terceros.fincawizard.v1.ActualizarLotesRequest
 */
export type ActualizarLotesRequest = Message<"sextante.terceros.fincawizard.v1.ActualizarLotesRequest"> & {
  /**
   * @generated from field: string registro_id = 1;
   */
  registroId: string;

  /**
   * @generated from field: repeated sextante.terceros.fincawizard.v1.LoteActualizacion lotes = 2;
   */
  lotes: LoteActualizacion[];
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.ActualizarLotesRequest.
 * Use `create(ActualizarLotesRequestSchema)` to create a new message.
 */
export const ActualizarLotesRequestSchema: GenMessage<ActualizarLotesRequest> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 45);

/**
 * Sin datos: que el rpc no falle ya indica que se guardo.
 *
 * @generated from message sextante.terceros.fincawizard.v1.ActualizarLotesResponse
 */
export type ActualizarLotesResponse = Message<"sextante.terceros.fincawizard.v1.ActualizarLotesResponse"> & {
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.ActualizarLotesResponse.
 * Use `create(ActualizarLotesResponseSchema)` to create a new message.
 */
export const ActualizarLotesResponseSchema: GenMessage<ActualizarLotesResponse> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 46);

/**
 * Paso que se confirma.
 *
 * @generated from message sextante.terceros.fincawizard.v1.AvanzarPasoRequest
 */
export type AvanzarPasoRequest = Message<"sextante.terceros.fincawizard.v1.AvanzarPasoRequest"> & {
  /**
   * @generated from field: string registro_id = 1;
   */
  registroId: string;

  /**
   * De 1 a 5. Desde el 3 exige que el registro tenga area, y desde el 4, al menos un lote.
   *
   * @generated from field: int32 paso = 2;
   */
  paso: number;
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.AvanzarPasoRequest.
 * Use `create(AvanzarPasoRequestSchema)` to create a new message.
 */
export const AvanzarPasoRequestSchema: GenMessage<AvanzarPasoRequest> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 47);

/**
 * Sin datos: que el rpc no falle ya indica que el paso quedo confirmado.
 *
 * @generated from message sextante.terceros.fincawizard.v1.AvanzarPasoResponse
 */
export type AvanzarPasoResponse = Message<"sextante.terceros.fincawizard.v1.AvanzarPasoResponse"> & {
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.AvanzarPasoResponse.
 * Use `create(AvanzarPasoResponseSchema)` to create a new message.
 */
export const AvanzarPasoResponseSchema: GenMessage<AvanzarPasoResponse> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 48);

/**
 * Registro que se vuelca a la finca.
 *
 * @generated from message sextante.terceros.fincawizard.v1.FinalizarRequest
 */
export type FinalizarRequest = Message<"sextante.terceros.fincawizard.v1.FinalizarRequest"> & {
  /**
   * @generated from field: string registro_id = 1;
   */
  registroId: string;
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.FinalizarRequest.
 * Use `create(FinalizarRequestSchema)` to create a new message.
 */
export const FinalizarRequestSchema: GenMessage<FinalizarRequest> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 49);

/**
 * Registro que se descarta.
 *
 * @generated from message sextante.terceros.fincawizard.v1.DescartarRequest
 */
export type DescartarRequest = Message<"sextante.terceros.fincawizard.v1.DescartarRequest"> & {
  /**
   * @generated from field: string registro_id = 1;
   */
  registroId: string;
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.DescartarRequest.
 * Use `create(DescartarRequestSchema)` to create a new message.
 */
export const DescartarRequestSchema: GenMessage<DescartarRequest> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 50);

/**
 * Sin datos: que el rpc no falle ya indica que se descarto.
 *
 * @generated from message sextante.terceros.fincawizard.v1.DescartarResponse
 */
export type DescartarResponse = Message<"sextante.terceros.fincawizard.v1.DescartarResponse"> & {
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.DescartarResponse.
 * Use `create(DescartarResponseSchema)` to create a new message.
 */
export const DescartarResponseSchema: GenMessage<DescartarResponse> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 51);

/**
 * Nombre de finca a validar.
 *
 * @generated from message sextante.terceros.fincawizard.v1.ValidarNombreRequest
 */
export type ValidarNombreRequest = Message<"sextante.terceros.fincawizard.v1.ValidarNombreRequest"> & {
  /**
   * @generated from field: string nombre = 1;
   */
  nombre: string;
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.ValidarNombreRequest.
 * Use `create(ValidarNombreRequestSchema)` to create a new message.
 */
export const ValidarNombreRequestSchema: GenMessage<ValidarNombreRequest> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 52);

/**
 * Sin datos: que el rpc no falle ya indica que el nombre esta libre.
 *
 * @generated from message sextante.terceros.fincawizard.v1.ValidarNombreResponse
 */
export type ValidarNombreResponse = Message<"sextante.terceros.fincawizard.v1.ValidarNombreResponse"> & {
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.ValidarNombreResponse.
 * Use `create(ValidarNombreResponseSchema)` to create a new message.
 */
export const ValidarNombreResponseSchema: GenMessage<ValidarNombreResponse> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 53);

/**
 * Area de finca a validar.
 *
 * @generated from message sextante.terceros.fincawizard.v1.ValidarGeometriaRequest
 */
export type ValidarGeometriaRequest = Message<"sextante.terceros.fincawizard.v1.ValidarGeometriaRequest"> & {
  /**
   * WKB Polygon, ver PostgisFunctions.AsBinary / wkbUtils.ts del cliente.
   *
   * @generated from field: bytes area_geografica_satelite = 1;
   */
  areaGeograficaSatelite: Uint8Array;
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.ValidarGeometriaRequest.
 * Use `create(ValidarGeometriaRequestSchema)` to create a new message.
 */
export const ValidarGeometriaRequestSchema: GenMessage<ValidarGeometriaRequest> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 54);

/**
 * Sin datos: que el rpc no falle ya indica que el area es valida.
 *
 * @generated from message sextante.terceros.fincawizard.v1.ValidarGeometriaResponse
 */
export type ValidarGeometriaResponse = Message<"sextante.terceros.fincawizard.v1.ValidarGeometriaResponse"> & {
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.ValidarGeometriaResponse.
 * Use `create(ValidarGeometriaResponseSchema)` to create a new message.
 */
export const ValidarGeometriaResponseSchema: GenMessage<ValidarGeometriaResponse> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 55);

/**
 * Lote dibujado en el asistente.
 *
 * @generated from message sextante.terceros.fincawizard.v1.LoteItem
 */
export type LoteItem = Message<"sextante.terceros.fincawizard.v1.LoteItem"> & {
  /**
   * @generated from field: string nombre_lote = 1;
   */
  nombreLote: string;

  /**
   * WKB Polygon.
   *
   * @generated from field: bytes area_geografica_polygon = 2;
   */
  areaGeograficaPolygon: Uint8Array;

  /**
   * @generated from field: optional string lote_origen_id = 3;
   */
  loteOrigenId?: string | undefined;

  /**
   * true si el lote cuenta para las hectareas productivas de la finca.
   *
   * @generated from field: bool is_area_productiva = 4;
   */
  isAreaProductiva: boolean;

  /**
   * Cultivo del lote, si ya se eligio.
   *
   * @generated from field: optional string cultivo_id = 5;
   */
  cultivoId?: string | undefined;
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.LoteItem.
 * Use `create(LoteItemSchema)` to create a new message.
 */
export const LoteItemSchema: GenMessage<LoteItem> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 56);

/**
 * Finca nueva con su area y sus lotes.
 *
 * @generated from message sextante.terceros.fincawizard.v1.GuardarRequest
 */
export type GuardarRequest = Message<"sextante.terceros.fincawizard.v1.GuardarRequest"> & {
  /**
   * @generated from field: string nombre = 1;
   */
  nombre: string;

  /**
   * 0 = Agricultura, 1 = Ganaderia.
   *
   * @generated from field: int32 tipo = 2;
   */
  tipo: number;

  /**
   * WKB Polygon.
   *
   * @generated from field: bytes area_geografica_satelite = 3;
   */
  areaGeograficaSatelite: Uint8Array;

  /**
   * @generated from field: repeated sextante.terceros.fincawizard.v1.LoteItem lotes = 4;
   */
  lotes: LoteItem[];
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.GuardarRequest.
 * Use `create(GuardarRequestSchema)` to create a new message.
 */
export const GuardarRequestSchema: GenMessage<GuardarRequest> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 57);

/**
 * Area y lotes para completar una finca que ya existe.
 *
 * @generated from message sextante.terceros.fincawizard.v1.CompletarFincaRequest
 */
export type CompletarFincaRequest = Message<"sextante.terceros.fincawizard.v1.CompletarFincaRequest"> & {
  /**
   * @generated from field: string finca_id = 1;
   */
  fincaId: string;

  /**
   * 0 = Agricultura, 1 = Ganaderia. La finca de Plataforma puede no traer tipo util todavia; este
   * wizard lo sigue pidiendo (paso 1) y acá se confirma/corrige.
   *
   * @generated from field: int32 tipo = 2;
   */
  tipo: number;

  /**
   * WKB Polygon.
   *
   * @generated from field: bytes area_geografica_satelite = 3;
   */
  areaGeograficaSatelite: Uint8Array;

  /**
   * @generated from field: repeated sextante.terceros.fincawizard.v1.LoteItem lotes = 4;
   */
  lotes: LoteItem[];
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.CompletarFincaRequest.
 * Use `create(CompletarFincaRequestSchema)` to create a new message.
 */
export const CompletarFincaRequestSchema: GenMessage<CompletarFincaRequest> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 58);

/**
 * Lote ya escrito en terceros.tbl_cliente_finca_lote por Guardar/CompletarFinca/Finalizar. Mismo set
 * de campos que Lote (login.proto): con esto el cliente llena el store de lotes de
 * GrpcFincaLoteDatabase para la finca recien creada, sin esperar al proximo login. No se importa
 * login.proto por el mismo criterio que GuardarResponse (dominios gRPC aislados).
 *
 * @generated from message sextante.terceros.fincawizard.v1.LoteGuardado
 */
export type LoteGuardado = Message<"sextante.terceros.fincawizard.v1.LoteGuardado"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string finca_id = 2;
   */
  fincaId: string;

  /**
   * @generated from field: string nombre_lote = 3;
   */
  nombreLote: string;

  /**
   * @generated from field: double area_hectareas = 4;
   */
  areaHectareas: number;

  /**
   * @generated from field: double area_cuadras = 5;
   */
  areaCuadras: number;

  /**
   * @generated from field: bool is_area_productiva = 6;
   */
  isAreaProductiva: boolean;

  /**
   * WKB Polygon.
   *
   * @generated from field: bytes area_geografica = 7;
   */
  areaGeografica: Uint8Array;

  /**
   * @generated from field: optional string cultivo_id = 8;
   */
  cultivoId?: string | undefined;

  /**
   * @generated from field: optional string cultivo_nombre = 9;
   */
  cultivoNombre?: string | undefined;
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.LoteGuardado.
 * Use `create(LoteGuardadoSchema)` to create a new message.
 */
export const LoteGuardadoSchema: GenMessage<LoteGuardado> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 59);

/**
 * Hasta el 2026-09-12 esto era solo {id}: ClienteAsideMenuRender usaba el id para seleccionar la
 * finca recien creada y disparaba un refresco por REST (fx_createFincaGetListByClienteIdService)
 * para traer el resto. Ese REST ya no existe en ese flujo (ver login.proto, mensaje Finca) asi que
 * esta respuesta pasa a devolver la finca completa -mismos campos que Finca-, y el cliente hace
 * upsert directo en GrpcFincaLoteDatabase en vez de refetchear. No se referencia el mensaje Finca de
 * login.proto con "import": son dominios gRPC deliberadamente aislados (ver CLAUDE.md, seccion "los
 * servicios gRPC no reusan la capa de servicios REST"), se prefiere repetir el mismo set de campos
 * a acoplar dos protos de dominios distintos.
 * 
 * "lotes" (campo 23, agregado el 2026-09-28) SI viaja, a diferencia de lo que decia este comentario
 * hasta entonces: ClienteAsideMenuRender._esCompletaAsync pasa a leer el store de lotes de
 * GrpcFincaLoteDatabase (una finca sin lotes cacheados no es "completa"), y ese store solo lo
 * llenaba el login. Sin los lotes aca, la finca recien creada por el wizard quedaba marcada como
 * incompleta hasta el proximo login.
 *
 * @generated from message sextante.terceros.fincawizard.v1.GuardarResponse
 */
export type GuardarResponse = Message<"sextante.terceros.fincawizard.v1.GuardarResponse"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string nombre_finca = 2;
   */
  nombreFinca: string;

  /**
   * @generated from field: double hectareas_finca = 3;
   */
  hectareasFinca: number;

  /**
   * @generated from field: double hectareas_productivas = 4;
   */
  hectareasProductivas: number;

  /**
   * 0 = Agricultura, 1 = Ganaderia.
   *
   * @generated from field: int32 tipo_finca = 5;
   */
  tipoFinca: number;

  /**
   * WKB Point.
   *
   * @generated from field: optional bytes ubicacion = 6;
   */
  ubicacion?: Uint8Array | undefined;

  /**
   * WKB Polygon: el area de la finca.
   *
   * @generated from field: optional bytes satelite_area_geografica = 7;
   */
  sateliteAreaGeografica?: Uint8Array | undefined;

  /**
   * @generated from field: string cliente_id = 8;
   */
  clienteId: string;

  /**
   * @generated from field: optional string departamento_id = 9;
   */
  departamentoId?: string | undefined;

  /**
   * @generated from field: optional string departamento_nombre = 10;
   */
  departamentoNombre?: string | undefined;

  /**
   * @generated from field: optional string municipio_id = 11;
   */
  municipioId?: string | undefined;

  /**
   * @generated from field: optional string municipio_nombre = 12;
   */
  municipioNombre?: string | undefined;

  /**
   * @generated from field: optional string departamento_region_id = 13;
   */
  departamentoRegionId?: string | undefined;

  /**
   * @generated from field: optional string departamento_region_nombre = 14;
   */
  departamentoRegionNombre?: string | undefined;

  /**
   * @generated from field: double ganaderia_crecimiento_diario_gr = 15;
   */
  ganaderiaCrecimientoDiarioGr: number;

  /**
   * @generated from field: int32 ganaderia_dias_descanso_optimo = 16;
   */
  ganaderiaDiasDescansoOptimo: number;

  /**
   * @generated from field: int32 ganaderia_dias_ocupacion_optimo = 17;
   */
  ganaderiaDiasOcupacionOptimo: number;

  /**
   * @generated from field: double ganaderia_animales_x_hectarea_optimo = 18;
   */
  ganaderiaAnimalesXHectareaOptimo: number;

  /**
   * @generated from field: int32 arboles_monitorear = 19;
   */
  arbolesMonitorear: number;

  /**
   * @generated from field: optional string uri_ortomosaico = 20;
   */
  uriOrtomosaico?: string | undefined;

  /**
   * @generated from field: optional string conteo_pre_render = 21;
   */
  conteoPreRender?: string | undefined;

  /**
   * Ultimo paso del registro de la finca que se completo. No dice si la finca esta completa: eso es tener
   * area y al menos un lote.
   *
   * @generated from field: int32 paso_registro_completado = 22;
   */
  pasoRegistroCompletado: number;

  /**
   * Los lotes que se acaban de crear para esta finca (ver el comentario del mensaje).
   *
   * @generated from field: repeated sextante.terceros.fincawizard.v1.LoteGuardado lotes = 23;
   */
  lotes: LoteGuardado[];
};

/**
 * Describes the message sextante.terceros.fincawizard.v1.GuardarResponse.
 * Use `create(GuardarResponseSchema)` to create a new message.
 */
export const GuardarResponseSchema: GenMessage<GuardarResponse> = /*@__PURE__*/
  messageDesc(file_terceros_finca_wizard, 60);

/**
 * Asistente de registro de finca de la SPA Cliente. Logica propia del servicio gRPC, sin la capa vieja de
 * servicios. Ningun mensaje lleva el id del cliente: el servidor lo toma de la sesion, en vez de confiar en
 * un campo que manda la app. Los rechazos son InvalidArgument con un codigo en el trailer
 * wizard-error-code: NOMBRE_DUPLICADO, GEOMETRIA_INVALIDA, GEOMETRIA_SOLAPADA, TIPO_INVALIDO,
 * FINCA_NO_ENCONTRADA o FINCA_YA_COMPLETA. Requiere sesion de la app Cliente.
 *
 * @generated from service sextante.terceros.fincawizard.v1.ClienteFincaWizardService
 */
export const ClienteFincaWizardService: GenService<{
  /**
   * Valida que el cliente no tenga otra finca activa con ese nombre.
   *
   * @generated from rpc sextante.terceros.fincawizard.v1.ClienteFincaWizardService.ValidarNombre
   */
  validarNombre: {
    methodKind: "unary";
    input: typeof ValidarNombreRequestSchema;
    output: typeof ValidarNombreResponseSchema;
  },
  /**
   * Valida que el area dibujada sea una geometria valida y que no se superponga en un 30% o mas con otra
   * finca activa. Si la otra finca es de otro productor, no da sus datos.
   *
   * @generated from rpc sextante.terceros.fincawizard.v1.ClienteFincaWizardService.ValidarGeometria
   */
  validarGeometria: {
    methodKind: "unary";
    input: typeof ValidarGeometriaRequestSchema;
    output: typeof ValidarGeometriaResponseSchema;
  },
  /**
   * Crea la finca con su area y sus lotes, con las mismas validaciones, y la asocia al cliente de la sesion.
   * Devuelve la finca completa.
   *
   * @generated from rpc sextante.terceros.fincawizard.v1.ClienteFincaWizardService.Guardar
   */
  guardar: {
    methodKind: "unary";
    input: typeof GuardarRequestSchema;
    output: typeof GuardarResponseSchema;
  },
  /**
   * Completa (una sola vez) una finca EXISTENTE que no tiene AOI/lotes todavia -tipicamente creada por
   * el panel administrativo "Plataforma" (POST /terceros/fincas/save, solo el nombre es obligatorio
   * ahi) sin pasar nunca por este wizard. A diferencia de Guardar, no crea nada: toma la finca por
   * finca_id, la valida igual que Guardar (mismas reglas de geometria/lotes) y le carga AOI + lotes.
   * Rechaza si la finca ya tiene AOI (usar el flujo normal de edicion, no este). No toca nombre/id de
   * finca: esos ya existen. Devuelve el mismo GuardarResponse que Guardar (misma forma de finca
   * terminada, se reusa el mensaje en vez de duplicarlo).
   *
   * @generated from rpc sextante.terceros.fincawizard.v1.ClienteFincaWizardService.CompletarFinca
   */
  completarFinca: {
    methodKind: "unary";
    input: typeof CompletarFincaRequestSchema;
    output: typeof GuardarResponseSchema;
  },
  /**
   * El registro en curso del cliente (con sus lotes), o vacio si no tiene ninguno.
   *
   * @generated from rpc sextante.terceros.fincawizard.v1.ClienteFincaWizardService.ObtenerRegistroEnCurso
   */
  obtenerRegistroEnCurso: {
    methodKind: "unary";
    input: typeof ObtenerRegistroEnCursoRequestSchema;
    output: typeof ObtenerRegistroEnCursoResponseSchema;
  },
  /**
   * Abre (o retoma) el registro temporal para EDITAR una finca YA COMPLETA: lo siembra con el area y los
   * lotes que la finca tiene hoy y lo deja en ultimo_paso = 3, o sea listo para abrir en el paso 4
   * (dividir/unir lotes). Es lo contrario de CompletarFinca: aquella exige que la finca NO tenga area,
   * esta exige que la tenga -es justamente lo que se va a reorganizar-. Si ya hay un registro en curso
   * de esa misma finca lo devuelve tal cual, sin volver a sembrarlo: sembrar de nuevo perderia los
   * cortes que el usuario ya hizo.
   *
   * @generated from rpc sextante.terceros.fincawizard.v1.ClienteFincaWizardService.IniciarEdicionFinca
   */
  iniciarEdicionFinca: {
    methodKind: "unary";
    input: typeof IniciarEdicionFincaRequestSchema;
    output: typeof RegistroTemporalSchema;
  },
  /**
   * Paso 1: crea el registro o actualiza nombre/tipo. En modo completar (finca_id) el nombre sale de
   * la finca existente y no se valida contra duplicados.
   *
   * @generated from rpc sextante.terceros.fincawizard.v1.ClienteFincaWizardService.GuardarDatosBasicos
   */
  guardarDatosBasicos: {
    methodKind: "unary";
    input: typeof GuardarDatosBasicosRequestSchema;
    output: typeof RegistroTemporalSchema;
  },
  /**
   * Paso 2: fuente del AOI. Cambiarla descarta el AOI y los lotes guardados (venian de la otra fuente).
   *
   * @generated from rpc sextante.terceros.fincawizard.v1.ClienteFincaWizardService.GuardarFuente
   */
  guardarFuente: {
    methodKind: "unary";
    input: typeof GuardarFuenteRequestSchema;
    output: typeof GuardarFuenteResponseSchema;
  },
  /**
   * Paso 2 (camino "Cargar archivo KML"): el servidor LEE el archivo que el cliente ya subio a Azure
   * Blob con un SAS de escritura (StorageService.GetSasUploadUrl + PUT directo al blob, igual que
   * cualquier adjunto) y resuelve de una sola vez lo que antes hacia el navegador: parsear el KML/KMZ,
   * abrir los multipoligonos en poligonos independientes, tomar el nombre del Placemark si lo trae,
   * redondear a 7 decimales, depurar (invalidos, duplicados, solapados) y agrupar en poligonos padre.
   * 
   * Por que se movio aca: el parseo es sincronico y congelaba la pantalla, y la depuracion compara
   * todos los poligonos contra todos (O(n^2)) -con un archivo grande la app quedaba bloqueada varios
   * segundos, incluso corriendo en un Web Worker-. El redondeo a 7 decimales no es cosmetico: es el
   * que deja dos vertices a menos de 1 cm en la MISMA coordenada, que es lo que permite despues sellar
   * bordes, cortar y unir lotes sin rendijas.
   * 
   * Guarda en el registro: la fuente ("Archivo importado"), el archivo (blob, nombre y el aviso de lo
   * descartado) y los LOTES del archivo -los mismos que antes llegaban por IniciarLotes-. NO guarda el
   * area: devuelve los poligonos padre y el cliente los manda a GuardarAoi, que es el que calcula el
   * perimetro con ellos — exactamente el mismo camino que cuando el usuario dibuja a mano. Asi el flujo
   * de los pasos 3 y 4 no cambia: el 3 recibe las piezas padre con su id y el 4 los lotes ya
   * identificados.
   *
   * @generated from rpc sextante.terceros.fincawizard.v1.ClienteFincaWizardService.ImportarArchivoKml
   */
  importarArchivoKml: {
    methodKind: "unary";
    input: typeof ImportarArchivoKmlRequestSchema;
    output: typeof ImportarArchivoKmlResponseSchema;
  },
  /**
   * Pasos 2, 3 y 4: recibe las PIEZAS del area y CALCULA con ellas el perimetro global
   * (PerimetroGlobalGeometria: la union con puentes entre los bloques separados), lo valida con las
   * mismas reglas que ValidarGeometria y guarda las dos cosas. El perimetro lo armaba el navegador y
   * viajaba en aoi_satelite; se movio aca porque era el ultimo trabajo pesado del hilo principal y el
   * "Continuar" del paso 3 lo esperaba, asi que la pantalla se congelaba en el cambio de paso.
   * 
   * Se llama al importar un archivo (paso 2), cada vez que se termina, edita o borra un poligono
   * (paso 3) y cuando el paso 4 recalcula los padres desde los lotes; NO al pulsar "Continuar": por
   * eso no confirma el paso 3 (eso lo hace AvanzarPaso(3)). Si el area cambio, el avance vuelve al
   * paso 2 pero los lotes NO se borran: el "Continuar" del paso 3 decide cuales se conservan (los de
   * poligonos sin cambios). SIN PIEZAS deja el registro sin area y sin lotes.
   *
   * @generated from rpc sextante.terceros.fincawizard.v1.ClienteFincaWizardService.GuardarAoi
   */
  guardarAoi: {
    methodKind: "unary";
    input: typeof GuardarAoiRequestSchema;
    output: typeof GuardarAoiResponseSchema;
  },
  /**
   * Paso 3, modo Editar: UNA operacion sobre UN vertice de UNA pieza padre. Es el gemelo de
   * EditarVerticeLote (paso 4) y reemplaza al camino viejo, en el que el cliente aplicaba el vertice
   * en su memoria y despues mandaba GuardarAoi con la geometria COMPLETA de todas las piezas.
   * 
   * Por que: con un area importada de un KML esas piezas son cientos de kB de WKB por cada vertice
   * que se suelta, y el servidor tenia que reparsearlas todas, calzarlas por su WKT y revalidar el
   * area entera contra las demas fincas. Encima el cliente mandaba antes un POST WFS con el poligono
   * en GML solo para preguntarle a PostGIS si se solapaba. El arrastre se sentia mas lento que
   * cuando el paso 3 dibujaba con Leaflet. Aca viaja un punto.
   * 
   * El servidor aplica la operacion sobre la geometria GUARDADA (la autoridad), valida que la forma
   * no quede cruzada sobre si misma ni pisando otra pieza —lo que antes preguntaba ese WFS— y, si no
   * pasa, NO toca nada y responde VERTICE_INVALIDO. Actualiza la pieza, sus vertices y la columna
   * poligonos_padre (la que pinta el WMS), conservando la POSICION de cada pieza dentro del
   * MultiPolygon: ese indice es el que el cliente ya tiene en pantalla.
   * 
   * NO toca aoi_satelite: el perimetro se recalcula en el GuardarAoi que sale al terminar de editar
   * ("Continuar" o "Volver" esperan lo pendiente), no una vez por vertice. Mismo patron que el paso 4
   * con _programarSincronizarPadres.
   *
   * @generated from rpc sextante.terceros.fincawizard.v1.ClienteFincaWizardService.EditarVerticePoligonoPadre
   */
  editarVerticePoligonoPadre: {
    methodKind: "unary";
    input: typeof EditarVerticePoligonoPadreRequestSchema;
    output: typeof EditarVerticePoligonoPadreResponseSchema;
  },
  /**
   * Paso 3 ("Continuar"): alinea los lotes con los poligonos del mapa, contra lo que hay en la base.
   * Por cada pieza busca los lotes que se solapan con ella: si cubren mas del 99% de la pieza y la pieza
   * no fue editada, ya esta subdividida y se conservan sus lotes (la pieza no se agrega); si fue editada
   * (mas grande o mas chica), esos lotes se borran y la pieza pasa a ser un lote; una pieza sin lotes se
   * agrega como lote. Los lotes que no se solapan con ninguna pieza se borran. Devuelve los agregados.
   *
   * @generated from rpc sextante.terceros.fincawizard.v1.ClienteFincaWizardService.ConfirmarPiezas
   */
  confirmarPiezas: {
    methodKind: "unary";
    input: typeof ConfirmarPiezasRequestSchema;
    output: typeof LotesTemporalesResponseSchema;
  },
  /**
   * Paso 4: reemplaza TODOS los lotes del registro (lotes iniciales, o resincronizar el mapa completo).
   *
   * @generated from rpc sextante.terceros.fincawizard.v1.ClienteFincaWizardService.IniciarLotes
   */
  iniciarLotes: {
    methodKind: "unary";
    input: typeof IniciarLotesRequestSchema;
    output: typeof LotesTemporalesResponseSchema;
  },
  /**
   * Paso 4: dividir/unir. Borra por id, inserta los nuevos y ajusta la geometria de los vecinos.
   *
   * @generated from rpc sextante.terceros.fincawizard.v1.ClienteFincaWizardService.ReemplazarLotes
   */
  reemplazarLotes: {
    methodKind: "unary";
    input: typeof ReemplazarLotesRequestSchema;
    output: typeof LotesTemporalesResponseSchema;
  },
  /**
   * Paso 4: parte UN lote por una linea de corte. El corte lo hace el SERVIDOR; el cliente manda la
   * operacion (que lote y por donde), no el resultado.
   * 
   * Antes lo resolvia el navegador con turf y mandaba las dos mitades por ReemplazarLotes. El
   * problema no era el algoritmo sino quien lo corre: el resultado del corte es lo que se guarda, y
   * el servidor no tenia forma de verificarlo. Mismo criterio por el que la validez de una pieza, el
   * solape y los vertices del paso 3 ya se deciden aca.
   * 
   * Devuelve los lotes del registro COMPLETOS y actualizados: el corte reemplaza uno por dos y
   * ademas puede insertarle un vertice al borde de un vecino (ver LoteSplitGeometria.SellarBordes),
   * asi que no alcanza con devolver lo nuevo.
   *
   * @generated from rpc sextante.terceros.fincawizard.v1.ClienteFincaWizardService.DividirLote
   */
  dividirLote: {
    methodKind: "unary";
    input: typeof DividirLoteRequestSchema;
    output: typeof DividirLoteResponseSchema;
  },
  /**
   * Paso 4: une DOS lotes adyacentes en uno. La adyacencia se evalua aca y la union se hace aca,
   * igual que el corte: el cliente manda que dos lotes quiere unir, no la geometria resultante.
   * 
   * Rechaza con LOTES_NO_ADYACENTES si no comparten un TRAMO de borde. Tocarse en un solo punto no
   * alcanza: dos piezas que se cruzan en forma de X comparten un vertice y nada mas, y unirlas da
   * una figura pellizcada que no es un lote.
   *
   * @generated from rpc sextante.terceros.fincawizard.v1.ClienteFincaWizardService.UnirLotes
   */
  unirLotes: {
    methodKind: "unary";
    input: typeof UnirLotesRequestSchema;
    output: typeof UnirLotesResponseSchema;
  },
  /**
   * Paso 4: mueve, inserta o quita UN vertice de los lotes. Es TOPOLOGICO: el vertice se toca en
   * todos los lotes que lo comparten, no solo en el que el usuario agarro — si no, entre los dos
   * queda una rendija que el guardado final rechaza por solape.
   * 
   * El servidor valida que ninguna forma quede cruzada sobre si misma ni pisando a un vecino, y si
   * no pasa NO toca nada: rechaza con VERTICE_INVALIDO y el cliente recarga lo que hay en la base.
   *
   * @generated from rpc sextante.terceros.fincawizard.v1.ClienteFincaWizardService.EditarVerticeLote
   */
  editarVerticeLote: {
    methodKind: "unary";
    input: typeof EditarVerticeLoteRequestSchema;
    output: typeof EditarVerticeLoteResponseSchema;
  },
  /**
   * Paso 4, modo Dibujar: ¿el trazo que lleva el usuario se puede AUTOCERRAR contra un borde que ya
   * existe? No escribe nada: es la misma cuenta que hace DibujarLote con un trazo abierto, hecha de
   * antemano para poder preguntarle al usuario antes de crear nada.
   * 
   * Por que existe. El cliente daba el autocierre por hecho en cuanto el trazo tocaba dos vertices
   * conocidos y mandaba DibujarLote ahi mismo: si esos dos vertices no estaban sobre un mismo
   * contorno, o el contorno que los une producia un lote encima de otro, el usuario perdia el trazo
   * entero y recibia un error ("los lotes se solapan", "el trazo quedo abierto"). Eran dos clicks
   * desafortunados, no un error suyo.
   * 
   * Ahora el cliente pregunta al poner un punto sobre un vertice conocido. Si la respuesta es valida
   * muestra un modal para confirmar el autocierre; si no, no pasa nada y se sigue dibujando. Con eso
   * el trazo nunca se pierde por una combinacion que no cierra.
   *
   * @generated from rpc sextante.terceros.fincawizard.v1.ClienteFincaWizardService.ValidarAutocierreLote
   */
  validarAutocierreLote: {
    methodKind: "unary";
    input: typeof ValidarAutocierreLoteRequestSchema;
    output: typeof ValidarAutocierreLoteResponseSchema;
  },
  /**
   * Paso 4: crea un lote a partir del trazo que el usuario dibujo. La geometria final la decide el
   * servidor, igual que el corte, la union y los vertices: el cliente manda los puntos que clickeo,
   * no un lote armado.
   * 
   * Dos formas, segun como venga el trazo:
   * 
   *   cerrado -> el usuario volvio al primer vertice. El anillo es el trazo tal cual, y aca se
   *              valida lo que antes validaba el navegador (LoteSplitState.agregarLote): forma
   *              simple, area minima, dentro del poligono padre y sin pisar otro lote.
   *   abierto -> el usuario arranco sobre un vertice del poligono padre y termino sobre otro. El
   *              pedazo de borde del padre que falta para cerrar lo pone el servidor con la
   *              geometria guardada (ver LoteAutocierreGeometria). Asi el borde compartido queda
   *              exacto —son las mismas coordenadas del padre— y el usuario no tiene que clickear
   *              vertice por vertice todo el borde apoyandose en el snap.
   * 
   * Un trazo abierto cuyos extremos NO caen sobre vertices del mismo padre se rechaza con
   * TRAZO_ABIERTO: no hay con que cerrarlo.
   * 
   * Devuelve los lotes del registro COMPLETOS, mismo criterio que DividirLote.
   *
   * @generated from rpc sextante.terceros.fincawizard.v1.ClienteFincaWizardService.DibujarLote
   */
  dibujarLote: {
    methodKind: "unary";
    input: typeof DibujarLoteRequestSchema;
    output: typeof DibujarLoteResponseSchema;
  },
  /**
   * Pasos 4-6: nombre y/o asignacion (area productiva, cultivo, cobertura) por lote.
   *
   * @generated from rpc sextante.terceros.fincawizard.v1.ClienteFincaWizardService.ActualizarLotes
   */
  actualizarLotes: {
    methodKind: "unary";
    input: typeof ActualizarLotesRequestSchema;
    output: typeof ActualizarLotesResponseSchema;
  },
  /**
   * Marca un paso como confirmado (ultimo_paso = max(actual, paso)). Solo 1 a 5: el 6 lo pone Finalizar.
   *
   * @generated from rpc sextante.terceros.fincawizard.v1.ClienteFincaWizardService.AvanzarPaso
   */
  avanzarPaso: {
    methodKind: "unary";
    input: typeof AvanzarPasoRequestSchema;
    output: typeof AvanzarPasoResponseSchema;
  },
  /**
   * Paso 6: vuelca el registro a terceros si esta completo (REGISTRO_INCOMPLETO si no). El temporal
   * queda como historial con ultimo_paso = 6 y finca_id apuntando a la finca.
   *
   * @generated from rpc sextante.terceros.fincawizard.v1.ClienteFincaWizardService.Finalizar
   */
  finalizar: {
    methodKind: "unary";
    input: typeof FinalizarRequestSchema;
    output: typeof GuardarResponseSchema;
  },
  /**
   * Descarta el registro en curso (borrado logico).
   *
   * @generated from rpc sextante.terceros.fincawizard.v1.ClienteFincaWizardService.Descartar
   */
  descartar: {
    methodKind: "unary";
    input: typeof DescartarRequestSchema;
    output: typeof DescartarResponseSchema;
  },
  /**
   * Ticket firmado para pedir las imagenes del mapa de UN registro en curso del cliente. Las imagenes
   * de Leaflet son <img> y no pueden mandar el token de sesion; el ticket va en su URL y solo sirve
   * para ese registro y por un tiempo corto (expira_en).
   *
   * @generated from rpc sextante.terceros.fincawizard.v1.ClienteFincaWizardService.ObtenerTicketMapa
   */
  obtenerTicketMapa: {
    methodKind: "unary";
    input: typeof ObtenerTicketMapaRequestSchema;
    output: typeof TicketMapaResponseSchema;
  },
  /**
   * Geometria de una pieza padre del paso 3, por su posicion (indice, 1-based) en poligonos_padre.
   *
   * @generated from rpc sextante.terceros.fincawizard.v1.ClienteFincaWizardService.LeerPiezaPadre
   */
  leerPiezaPadre: {
    methodKind: "unary";
    input: typeof LeerPiezaPadreRequestSchema;
    output: typeof GeometriaRegistroResponseSchema;
  },
  /**
   * Geometria de un lote del paso 4 (para el snap de Dividir), solo si es del registro.
   *
   * @generated from rpc sextante.terceros.fincawizard.v1.ClienteFincaWizardService.LeerLoteTemporal
   */
  leerLoteTemporal: {
    methodKind: "unary";
    input: typeof LeerLoteTemporalRequestSchema;
    output: typeof GeometriaRegistroResponseSchema;
  },
  /**
   * Vertices de una pieza del paso 3 (modo Editar), en el orden del anillo y sin el de cierre.
   *
   * @generated from rpc sextante.terceros.fincawizard.v1.ClienteFincaWizardService.LeerVerticesPieza
   */
  leerVerticesPieza: {
    methodKind: "unary";
    input: typeof LeerVerticesPiezaRequestSchema;
    output: typeof VerticesPiezaResponseSchema;
  },
  /**
   * Agrega un vertice al trazo en curso (paso 3 y 4, modo Dibujar). Las filas del trazo son las de
   * tbl_temp_vertices_dibujo con poligono_padre_id en nulo; las dibuja vw_dibujo_en_curso.
   *
   * @generated from rpc sextante.terceros.fincawizard.v1.ClienteFincaWizardService.AgregarVerticeTrazo
   */
  agregarVerticeTrazo: {
    methodKind: "unary";
    input: typeof AgregarVerticeTrazoRequestSchema;
    output: typeof TrazoResponseSchema;
  },
  /**
   * Quita un vertice del trazo por su orden (deshacer).
   *
   * @generated from rpc sextante.terceros.fincawizard.v1.ClienteFincaWizardService.QuitarVerticeTrazo
   */
  quitarVerticeTrazo: {
    methodKind: "unary";
    input: typeof QuitarVerticeTrazoRequestSchema;
    output: typeof TrazoResponseSchema;
  },
  /**
   * Borra el trazo entero del registro (al cerrar o cancelar la forma). Las filas de piezas guardadas
   * no se tocan.
   *
   * @generated from rpc sextante.terceros.fincawizard.v1.ClienteFincaWizardService.LimpiarTrazo
   */
  limpiarTrazo: {
    methodKind: "unary";
    input: typeof LimpiarTrazoRequestSchema;
    output: typeof TrazoResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_terceros_finca_wizard, 0);

